// import React, { useEffect, useState } from "react";
// import { Button, IconButton } from "@mui/material";
// import { RemoveRedEye } from "@mui/icons-material";
// import { Visibility, Edit, Delete } from "@mui/icons-material";
// import { Close } from "@mui/icons-material";
// import layoutImage from "../../../assets/images/girl.webp";
// import {
//   Box,
//   Grid,
//   Typography,
//   TextField,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Card,
//   CardHeader,
//   CardContent,
//   Tooltip,
//   Dialog,
//   DialogActions,
//   FormControlLabel,
//   FormGroup,
//   Checkbox,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   TablePagination,
//   DialogContent,
//   DialogTitle,
//   Modal,
// } from "@mui/material";
// import logo2 from "../../../assets/images/Picture2.png";
// import envisionLogo1 from "../../../assets/images/Picture2.png";

// import { ExpandMore } from "@mui/icons-material";

// const Summery = () => {
//   const [showForm, setShowForm] = useState(false);
//   const handleAccordionChange = (panel) => {
//     setExpandedPanel(expandedPanel === panel ? null : panel);
//   };


//   const openPersonalView = () => {};
// const editPersonal = () => {};

// const openFamilyView = () => {};
// const editFamily = () => {};

// const openEducationView = () => {};
// const editEducation = () => {};

// const openWorkView = () => {};
// const editWorkExperience = () => {};

// const openAgreeView = () => {};
// const editWorkAgreement = () => {};

// const openHandBookView = () => {};
// const editHandbook = () => {};

// const handlePrev = () => {};
// const handleNext = () => {};

// const handleChangeC = () => {};
// const selectFileSign2 = () => {};
// const closeImage = () => {};

//   const handleViewClick = (index) => {
//     if (index === 0) {
//       setOpenS(true);
//     } else if (index === 1) {
//       setOpenF(true); // Redirect to Family Page for the second row
//     } else if (index === 2) {
//       setOpenE(true); // Redirect to Family Page for the second row
//     } else if (index === 3) {
//       setOpenW(true); // Redirect to Family Page for the second row
//     } else if (index === 4) {
//       setOpenA(true); // Redirect to Family Page for the second row
//     } else if (index === 5) {
//       setOpenVW(true);
//       // Redirect to Family Page for the second row
//     }
//   };
//   const [selectedSection, setSelectedSection] = useState("PERSONAL");
//   const handleEditClick = (index) => {
//     if (index === 0) {
//       setSelectedSection("PERSONAL"); // Redirect to Personal Page for the first row
//     } else if (index === 1) {
//       setSelectedSection("FAMILY"); // Redirect to Family Page for the second row
//     } else if (index === 2) {
//       setSelectedSection("EDUCATION"); // Redirect to Family Page for the second row
//     } else if (index === 3) {
//       setSelectedSection("WORK EXPERIENCE"); // Redirect to Family Page for the second row
//     } else if (index === 4) {
//       setSelectedSection("AGREEMENT"); // Redirect to Family Page for the second row
//     } else if (index === 5) {
//       setSelectedSection("HANDBOOK"); // Redirect to Family Page for the second row
//     }
//   };
//   const [currentPage, setCurrentPage] = useState(1);
//   const [openVW, setOpenVW] = useState(false);
//   const [startPage, setStartPage] = useState(1);
//   const pageLimit = 3;
//   const pageLimit1 = 2;
//   const totalPages = 23;
//   const totalPages1 = 2;
//   const agreementdata = [
//     {
//       unit: "10th",
//       monthName: "March",
//       date: "Twenty Five",
//       employeeName: "John Doe",
//       employeeFathersName: "Richard Doe",
//       age: 30,
//       presentAddress: "123, ABC Street, Hyderabad",
//       permanentAddress: "456, XYZ Road, Bangalore",
//       serviceCommitment: 2,
//       custodyOf: "ID Proofs and Bank Cheque",
//       serviceBreakAmount: 50000,
//       serviceBreakAmount: 1000,
//       agreementDate: "08/02/2025",
//     },
//   ];
//   const [currentPage1, setCurrentPage1] = useState(1);
//   const [openA, setOpenA] = useState(false);
//   const [openW, setOpenW] = useState(false);
//   const [openE, setOpenE] = useState(false);
//   const [addresses, setAddresses] = useState([{}]);
//   const [openf, setOpenF] = useState(false);
//   const [expandedPanel, setExpandedPanel] = useState(null);
//   const [checked, setChecked] = useState(false);
// const [signature, setSignature] = useState(null);
// const [bytecodeimage2, setBytecodeimage2] = useState(null);

//   const S = [
//     {
//       id: 1,
//       title: "Personal Detials",
//       image: "images/iStock.jpg",
//       details: "personal",
//     },
//     { id: 2, title: "Address Detials", image: "pop.png", details: "family" },
//     { id: 3, title: "KYC Detials", image: "da.png", details: "education" },
//     { id: 4, title: "Bank Detials", image: "pop.png", details: "work" },
//     { id: 5, title: "Social Profile", image: "da.png", details: "address" },
//   ];

//   const [opens, setOpenS] = useState(false);
//   const data = [
//     {
//       id: 1,
//       description: "Personal",
//       status: "Pending",
//       viewHandler: () => openPersonalView(1),
//       editHandler: () => editPersonal(),
//     },
//     {
//       id: 2,
//       description: "Family",
//       status: "Pending",
//       viewHandler: () => openFamilyView(2),
//       editHandler: () => editFamily(),
//     },
//     {
//       id: 3,
//       description: "Education",
//       status: "Pending",
//       viewHandler: () => openEducationView(3),
//       editHandler: () => editEducation(),
//     },
//     {
//       id: 4,
//       description: "Work Experience",
//       status: "Pending",
//       viewHandler: () => openWorkView(4),
//       editHandler: () => editWorkExperience(),
//     },
//     {
//       id: 5,
//       description: "Agreement",
//       status: "Pending",
//       viewHandler: () => openAgreeView(5),
//       editHandler: () => editWorkAgreement(),
//     },
//     {
//       id: 6,
//       description: "HandBook",
//       status: "Pending",
//       viewHandler: () => openHandBookView(6),
//       editHandler: () => editHandbook(),
//     },
//   ];

//   return (
//     <div>
//       <div className="container-fluid">
//         <div className="row">
//           <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-12">
//             <Box
//               sx={{
//                 marginTop: "1%",
//                 padding: "1rem",
//                 maxHeight: "500px",
//                 overflowY: "auto",
//                 scrollbarWidth: "none", // Hides scrollbar in Firefox
//                 "&::-webkit-scrollbar": {
//                   display: "none", // Hides scrollbar in Chrome, Safari, Edge
//                 },
//               }}
//             >
//               <CardContent>
//                 <TableContainer sx={{  marginTop: "70px" ,marginBottom:"-40px"}}>
//                   <Table sx={{ border: "2px solid black", minWidth: "1000px" }}>
//                     <TableHead>
//                       <TableRow
//                         sx={{
//                           backgroundColor: "#D6E0F5",
//                           height: "40px",
//                         }}
//                       >
//                         <TableCell
//                           sx={{
//                             borderRight: "1px solid black",
//                             py: 0.8,
//                             px: 1.2,
//                             lineHeight: "1.3",
//                             textAlign: "center",
//                           }}
//                         >
//                           S.No
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             borderRight: "1px solid black",
//                             py: 0.8,
//                             px: 1.2,
//                             lineHeight: "1.3",
//                             textAlign: "center",
//                           }}
//                         >
//                           Description
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             borderRight: "1px solid black",
//                             py: 0.8,
//                             px: 1.2,
//                             lineHeight: "1.3",
//                             textAlign: "center",
//                           }}
//                         >
//                           Status
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             borderRight: "1px solid black",
//                             py: 0.8,
//                             px: 1.2,
//                             lineHeight: "1.3",
//                             textAlign: "center",
//                           }}
//                         >
//                           Action
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             py: 0.8,
//                             px: 1.2,
//                             lineHeight: "1.3",
//                             textAlign: "center",
//                           }}
//                         >
//                           Remarks
//                         </TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {data.map((row, index) => (
//                         <TableRow key={index} sx={{ height: "40px" }}>
//                           <TableCell
//                             sx={{
//                               borderRight: "1px solid black",
//                               py: 0.8,
//                               px: 1.2,
//                               lineHeight: "1.3",
//                               textAlign: "center",
//                             }}
//                           >
//                             {row.id}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               borderRight: "1px solid black",
//                               py: 0.8,
//                               px: 1.2,
//                               lineHeight: "1.3",
//                               textAlign: "center",
//                             }}
//                           >
//                             {row.description}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               borderRight: "1px solid black",
//                               py: 0.8,
//                               px: 1.2,
//                               lineHeight: "1.3",
//                               textAlign: "center",
//                             }}
//                           >
//                             {row.status}
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               borderRight: "1px solid black",
//                               py: 0.8,
//                               px: 1.2,
//                               lineHeight: "1.3",
//                               textAlign: "center",
//                             }}
//                           >
//                             <Tooltip title="View">
//                               <IconButton
//                                 onClick={() => handleViewClick(index)}
//                                 color="primary"
//                                 size="small"
//                               >
//                                 <RemoveRedEye fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                             <Tooltip title="Edit">
//                               <IconButton
//                                 onClick={() => handleEditClick(index)}
//                                 color="secondary"
//                                 size="small"
//                               >
//                                 <Edit fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           </TableCell>
//                           <TableCell
//                             sx={{
//                               py: 0.8,
//                               px: 1.2,
//                               lineHeight: "1.3",
//                               textAlign: "center",
//                             }}
//                           >
//                             Nothing
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 <Dialog
//                   style={{
//                     marginTop: "270px",
//                     height: "80vh",
//                     marginLeft: "15%",
//                     marginTop:"60px",
//                      marginRight:"160px",
//                      borderRadius:"40px",
//                   }}
//                   open={opens}
//                   onClose={() => setOpenS(false)}
//                   maxWidth="md"
//                   fullWidth
//                  >
//                   <DialogTitle>
//                     Personal Info
//                     <IconButton
//                       onClick={() => setOpenS(false)}
//                       sx={{ position: "absolute", right: 10, top: 10 }}
//                     >
//                       <Close color="error" />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     {S.map((item, index) => (
//                       <Accordion
//                         key={item.id}
//                         expanded={expandedPanel === index}
//                         onChange={() => handleAccordionChange(index)}
//                       >
//                         <AccordionSummary
//                           expandIcon={<ExpandMore />}
//                           sx={{ backgroundColor: "#D6E0F5" }}
//                         >
//                           <Typography>{item.title}</Typography>
//                         </AccordionSummary>
//                         <AccordionDetails>
//                           {/* If "Personal Details" is expanded, show details exactly as in the image */}
//                           {expandedPanel === index ? (
//                             index === 0 ? (
//                               <>
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     marginBottom: "15px",
//                                   }}
//                                 >
//                                   <img
//                                     src={logo2}
//                                     alt="Profile"
//                                     style={{
//                                       width: 100,
//                                       height: 100,
//                                       borderRadius: "8px",
//                                     }}
//                                   />
//                                 </div>
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     flexWrap: "wrap",
//                                     justifyContent: "space-between",
//                                   }}
//                                 >
//                                   {/* Left Column */}
//                                   <div>
//                                     <p>
//                                       <strong>First Name</strong>
//                                       <br />
//                                       Anirudh
//                                     </p>
//                                     <p>
//                                       <strong>Gender</strong>
//                                       <br />
//                                       Male
//                                     </p>
//                                     <p>
//                                       <strong>Mother's Name</strong>
//                                       <br />
//                                       Srilatha
//                                     </p>
//                                   </div>

//                                   {/* Middle Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Middle Name</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Blood Group</strong>
//                                       <br />
//                                       A+
//                                     </p>
//                                     <p>
//                                       <strong>Personal Mail Id</strong>
//                                       <br />
//                                       anirudhmarripally912@gmail.com
//                                     </p>
//                                   </div>

//                                   {/* Right Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Last Name</strong>
//                                       <br />
//                                       Marripally
//                                     </p>
//                                     <p>
//                                       <strong>Marital Status</strong>
//                                       <br />
//                                       Single
//                                     </p>
//                                     <p>
//                                       <strong>Phone Number</strong>
//                                       <br />
//                                       7569532673
//                                     </p>
//                                   </div>

//                                   {/* Extra Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Date Of Birth</strong>
//                                       <br />
//                                       11-03-1994
//                                     </p>
//                                     <p>
//                                       <strong>Father's Name</strong>
//                                       <br />
//                                       Satyanarayana Charyulu
//                                     </p>
//                                     <p>
//                                       <strong>Alternative Phone Number</strong>
//                                       <br />
//                                     </p>
//                                   </div>
//                                 </div>
//                               </>
//                             ) : index === 1 ? (
//                               <>
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     flexWrap: "wrap",
//                                     justifyContent: "space-between",
//                                   }}
//                                 >
//                                   {/* Left Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Country</strong>
//                                       <br />
//                                       India
//                                     </p>
//                                     <p>
//                                       <strong>State</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>City</strong>
//                                       <br />
//                                       Jane
//                                     </p>
//                                   </div>

//                                   {/* Middle Column */}
//                                   <div>
//                                     <p>
//                                       <strong>House No</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Area</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Landmark</strong>
//                                       <br />
//                                     </p>
//                                   </div>

//                                   {/* Right Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Pincode</strong>
//                                       <br />
//                                       Doe
//                                     </p>
//                                   </div>
//                                 </div>
//                               </>
//                             ) : index === 2 ? (
//                               <>
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     flexWrap: "wrap",
//                                     justifyContent: "space-between",
//                                   }}
//                                 >
//                                   {/* Left Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Aadhar Number</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Pancard Number</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Driving License</strong>
//                                       <br />
//                                     </p>
//                                   </div>

//                                   {/* Middle Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Aadhar FrontPage</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Pancard Frontpage</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Driving License FrontPage</strong>
//                                       <br />
//                                     </p>
//                                   </div>

//                                   {/* Right Column */}
//                                   <div>
//                                     <p>
//                                       <strong>Aadhar BackPage</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Pancard Backpage</strong>
//                                       <br />
//                                     </p>
//                                     <p>
//                                       <strong>Driving License Backpage</strong>
//                                       <br />
//                                     </p>
//                                   </div>
//                                 </div>
//                               </>
//                             ) : index === 4 ? (
//                               <>
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     flexWrap: "wrap",
//                                     justifyContent: "space-between",
//                                   }}
//                                 >
//                                   {/* Left Column */}

//                                   <p>
//                                     <strong>LinkdIn</strong>
//                                     <br />
//                                   </p>
//                                   <p>
//                                     <strong>FaceBook</strong>
//                                     <br />
//                                   </p>
//                                   <p>
//                                     <strong>Instragram</strong>
//                                     <br />
//                                   </p>
//                                 </div>
//                               </>
//                             ) : index === 3 ? (
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   flexWrap: "wrap",
//                                   justifyContent: "space-between",
//                                 }}
//                               >
//                                 {/* Left Column */}
//                                 <div>
//                                   <p>
//                                     <strong>Bank Holder Name</strong>
//                                     <br />
//                                   </p>
//                                   <p>
//                                     <strong>Bank Name</strong>
//                                     <br />
//                                   </p>
//                                   <p>
//                                     <strong>Account Number</strong>
//                                     <br />
//                                   </p>
//                                 </div>

//                                 {/* Middle Column */}
//                                 <div>
//                                   <p>
//                                     <strong>IFSC Code</strong>
//                                     <br />
//                                   </p>
//                                   <p>
//                                     <strong>Branch Name</strong>
//                                     <br />
//                                   </p>
//                                   <p>
//                                     <strong>Branch City</strong>
//                                     <br />
//                                   </p>
//                                 </div>

//                                 {/* Right Column */}
//                                 <div>
//                                   <p>
//                                     <strong>Bank Bassbook/Cheque</strong>
//                                     <br />
//                                   </p>
//                                 </div>
//                               </div>
//                             ) : (
//                               // Default case for other indexes (like index 2, 3, etc.)
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "10px",
//                                 }}
//                               >
//                                 <img
//                                   src={item.image}
//                                   alt={item.title}
//                                   style={{
//                                     width: 60,
//                                     height: 60,
//                                     borderRadius: "8px",
//                                   }}
//                                 />
//                               </div>
//                             )
//                           ) : null}
//                         </AccordionDetails>
//                       </Accordion>
//                     ))}
//                   </DialogContent>
//                 </Dialog>

//                 <Dialog
//                   style={{ marginTop: "10px", marginLeft: "8%" }}
//                   open={openf}
//                   onClose={() => setOpenF(false)}
//                   maxWidth="md"
//                   fullWidth
//                 >
//                   <DialogTitle>
//                     Family Info
//                     <IconButton
//                       onClick={() => setOpenF(false)}
//                       sx={{ position: "absolute", right: 10, top: 10 }}
//                     >
//                       <Close color="error" />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <TableContainer
//                       component={Paper}
//                       sx={{ border: "1px solid #ccc" }}
//                     >
//                       <Table>
//                         <TableHead>
//                           <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
//                             {[
//                               "S.NO",
//                               "Name",
//                               "Relationship",
//                               "Age",
//                               "Date Of Birth",
//                               "Phone Number",
//                               "Pin Code",
//                               "Address",
//                             ].map((header) => (
//                               <TableCell
//                                 key={header}
//                                 align="center"
//                                 sx={{
//                                   fontWeight: "bold",
//                                   border: "1px solid #ccc",
//                                   lineHeight: "1",
//                                 }}
//                               >
//                                 {header}
//                               </TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {addresses.map((_, index) => (
//                             <TableRow key={index} sx={{ height: "30px" }}>
//                               {" "}
//                               {/* Adjust row height */}
//                               {[...Array(8)].map((_, i) => (
//                                 <TableCell
//                                   key={i}
//                                   align="center"
//                                   sx={{
//                                     border: "1px solid #ccc",
//                                     padding: "4px", // Reduce padding
//                                     lineHeight: "1", // Decrease line spacing
//                                     fontSize: "14px", // Optionally decrease font size
//                                   }}
//                                 >
//                                   {/* <input type="text" style={{ width: "100%" }} /> */}
//                                 </TableCell>
//                               ))}
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </DialogContent>
//                 </Dialog>

//                 <Dialog
//                   style={{ marginTop: "10px", marginLeft: "8%" }}
//                   open={openE}
//                   onClose={() => setOpenE(false)}
//                   maxWidth="md"
//                   fullWidth
//                 >
//                   <DialogTitle>
//                     Education Info
//                     <IconButton
//                       onClick={() => setOpenE(false)}
//                       sx={{ position: "absolute", right: 10, top: 10 }}
//                     >
//                       <Close color="error" />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <TableContainer
//                       component={Paper}
//                       sx={{ border: "1px solid #ccc" }}
//                     >
//                       <Table>
//                         <TableHead>
//                           <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
//                             {[
//                               "S.NO",
//                               "Qualification",
//                               "Course Type",
//                               "Stream",
//                               "Start Date",
//                               "End Date",
//                               "College/University",
//                             ].map((header) => (
//                               <TableCell
//                                 key={header}
//                                 align="center"
//                                 sx={{
//                                   fontWeight: "bold",
//                                   border: "1px solid #ccc",
//                                   lineHeight: "1",
//                                 }}
//                               >
//                                 {header}
//                               </TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {addresses.map((_, index) => (
//                             <TableRow key={index} sx={{ height: "30px" }}>
//                               {" "}
//                               {/* Adjust row height */}
//                               {[...Array(7)].map((_, i) => (
//                                 <TableCell
//                                   key={i}
//                                   align="center"
//                                   sx={{
//                                     border: "1px solid #ccc",
//                                     padding: "4px", // Reduce padding
//                                     lineHeight: "1", // Decrease line spacing
//                                     fontSize: "14px", // Optionally decrease font size
//                                   }}
//                                 >
//                                   {/* <input type="text" style={{ width: "100%" }} /> */}
//                                 </TableCell>
//                               ))}
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </DialogContent>
//                 </Dialog>

//                 <Dialog
//                   style={{ marginTop: "10px", marginLeft: "8%" }}
//                   open={openW}
//                   onClose={() => setOpenW(false)}
//                   maxWidth="md"
//                   fullWidth
//                 >
//                   <DialogTitle>
//                     Work Info
//                     <IconButton
//                       onClick={() => setOpenW(false)}
//                       sx={{ position: "absolute", right: 10, top: 10 }}
//                     >
//                       <Close color="error" />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <TableContainer
//                       component={Paper}
//                       sx={{ border: "1px solid #ccc" }}
//                     >
//                       <Table>
//                         <TableHead>
//                           <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
//                             {[
//                               "S.NO",
//                               "Company Name",
//                               "Pervious Designation",
//                               "Tenure(To)",
//                               "Tenure(From)",
//                               "Last CTC",
//                               "College/University",
//                             ].map((header) => (
//                               <TableCell
//                                 key={header}
//                                 align="center"
//                                 sx={{
//                                   fontWeight: "bold",
//                                   border: "1px solid #ccc",
//                                   lineHeight: "1",
//                                 }}
//                               >
//                                 {header}
//                               </TableCell>
//                             ))}
//                           </TableRow>
//                         </TableHead>
//                         <TableBody>
//                           {addresses.map((_, index) => (
//                             <TableRow key={index} sx={{ height: "30px" }}>
//                               {" "}
//                               {/* Adjust row height */}
//                               {[...Array(6)].map((_, i) => (
//                                 <TableCell
//                                   key={i}
//                                   align="center"
//                                   sx={{
//                                     border: "1px solid #ccc",
//                                     padding: "4px", // Reduce padding
//                                     lineHeight: "1", // Decrease line spacing
//                                     fontSize: "14px", // Optionally decrease font size
//                                   }}
//                                 >
//                                   {/* <input type="text" style={{ width: "100%" }} /> */}
//                                 </TableCell>
//                               ))}
//                               <TableCell
//                                 align="center"
//                                 sx={{
//                                   border: "1px solid #ccc",
//                                   padding: "4px",
//                                 }}
//                               ></TableCell>
//                             </TableRow>
//                           ))}
//                         </TableBody>
//                       </Table>
//                     </TableContainer>
//                   </DialogContent>
//                 </Dialog>

//                 <Dialog
//                   style={{
//                     marginTop: "20px",
//                     maxHeight: "100vh",
//                     marginLeft: "8%",
//                   }}
//                   open={openA}
//                   onClose={() => setOpenA(false)}
//                   maxWidth="md"
//                   fullWidth
//                 >
//                   <DialogTitle>
//                     Agreement Info
//                     <IconButton
//                       onClick={() => setOpenA(false)}
//                       sx={{ position: "absolute", right: 10, top: 10 }}
//                     >
//                       <Close color="error" />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <div
//                       id="top"
//                       style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         minHeight: "100vh",
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: "210mm", // A4 width
//                           height: "297mm", // A4 height
//                           backgroundColor: "white", // Background color of the page
//                           padding: "10mm", // Ensuring proper spacing
//                           boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Optional: Adding a slight shadow
//                           overflow: "hidden",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         {agreementdata.map((data, index) => (
//                           <div
//                             key={index}
//                             style={{
//                               letterSpacing: "0.2px",
//                               textAlign: "justify",
//                             }}
//                           >
//                             {currentPage1 === 1 && (
//                               <>
//                                 <p>
//                                   THIS AGREEMENT made at Hyderabad on{" "}
//                                   <b>{data.unit}</b> day of{" "}
//                                   <b>{data.monthName}</b>, Two thousand and{" "}
//                                   <b>{data.date}</b>. BETWEEN
//                                   <b> {data.employeeName}</b>, S/o, D/o{" "}
//                                   <b>{data.employeeFathersName}</b>, aged{" "}
//                                   <b>{data.age}</b> years, residing at{" "}
//                                   <b>{data.presentAddress}</b> and having
//                                   permanent address at{" "}
//                                   <b>{data.permanentAddress}</b>.
//                                 </p>

//                                 <p style={{ textAlign: "center" }}>
//                                   <b>AND</b>
//                                 </p>

//                                 <p>
//                                   Envision Integrated Services Private Limited,
//                                   a company incorporated under the Companies Act
//                                   1956 and having its Corporate Office at #913,
//                                   9th Floor, Manjeera Trinity Corporate
//                                   Building, E-Seva Lane, KPHB, Hyderabad –
//                                   500085, Reg. Office at #8-3-940/5/501,
//                                   Tirumala Apartments, Yellareddyguda Cross
//                                   Roads, Ameerpet, Hyderabad, Telangana – 500038
//                                   (hereinafter referred to as “Employer”).
//                                 </p>

//                                 <p
//                                   style={{
//                                     letterSpacing: "0.8px",
//                                     fontSize: "18px",
//                                     fontWeight: "bold",
//                                     textDecoration: "underline",
//                                   }}
//                                 >
//                                   IT IS NOW HEREBY AGREED AS UNDER:
//                                 </p>

//                                 <p>
//                                   In consideration of the profession to be
//                                   imparted by the Employer, the Employee
//                                   undertakes irrevocably to serve the Employer
//                                   for a minimum period of{" "}
//                                   <b>{data.serviceCommitment}</b> year(s) from
//                                   the date of joining.
//                                 </p>

//                                 <p>
//                                   As a guarantee, the Employee agrees to keep
//                                   the following original documents & Bank
//                                   Cheques with the custody of the Employer:{" "}
//                                   <b>{data.custodyOf}</b>.
//                                 </p>

//                                 <p>
//                                   If the Employee resigns within the agreed
//                                   period, they shall be liable to pay liquidated
//                                   damages amounting to Rs{" "}
//                                   <b>
//                                     {data.serviceBreakAmount
//                                       ? data.serviceBreakAmount.toLocaleString(
//                                           "en-IN"
//                                         )
//                                       : ""}
//                                   </b>{" "}
//                                   /- (Rupees{" "}
//                                   <b>
//                                     {data.serviceBreakAmount
//                                       ? data.serviceBreakAmount.toLocaleString(
//                                           "en-IN"
//                                         )
//                                       : ""}
//                                   </b>{" "}
//                                   Only).
//                                 </p>

//                                 <p>
//                                   In case of an unauthorized absence of more
//                                   than three consecutive days, the Employer can
//                                   claim the employee’s cheque no.{" "}
//                                   <input
//                                     maxLength="6"
//                                     type="text"
//                                     name="claim"
//                                     style={{
//                                       width: "100px",
//                                       border: "0",
//                                       outline: "none",
//                                       fontSize: "15px",
//                                       letterSpacing: "2px",
//                                       borderBottom: "1px dashed black",
//                                     }}
//                                   />
//                                   ,{" "}
//                                   <input
//                                     maxLength="6"
//                                     type="text"
//                                     name="claim1"
//                                     style={{
//                                       width: "100px",
//                                       border: "0",
//                                       outline: "none",
//                                       fontSize: "15px",
//                                       letterSpacing: "2px",
//                                       borderBottom: "1px dashed black",
//                                     }}
//                                   />{" "}
//                                   for liquidated damages/compensation.
//                                 </p>

//                                 <p>
//                                   Any dispute arising from this agreement shall
//                                   be resolved by arbitration in Hyderabad as per
//                                   The Arbitration and Conciliation Act, 1996 or
//                                   of any modification or re-enactment thereof.
//                                   The venue of arbitration shall be Hyderabad.
//                                 </p>
//                                 <p>
//                                   During the period of{" "}
//                                   <span style={{ fontWeight: "bold" }}>2</span>{" "}
//                                   year (excluding Leave without pay period
//                                   and/or unauthorized absence, if any) from the
//                                   date of joining, if Employee
//                                   leaves/resigns/abandons the services or
//                                   violates the terms of this Agreement, Employee
//                                   will have to pay liquidated damages amounting
//                                   to Rs{" "}
//                                   <span style={{ fontWeight: "bold" }}>
//                                     2000
//                                   </span>{" "}
//                                   /- (Rupees{" "}
//                                   <span style={{ fontWeight: "bold" }}>
//                                     Only
//                                   </span>
//                                   ) and give Three calendar months’ written
//                                   notice or salary in lieu thereof. Employee
//                                   agrees that the said amount of Rs
//                                   <span style={{ fontWeight: "bold" }}>
//                                     1000
//                                   </span>{" "}
//                                   /- (Rupees{" "}
//                                   <span style={{ fontWeight: "bold" }}>
//                                     Only
//                                   </span>
//                                   ) can be recovered/adjusted by Employer from
//                                   the legal dues, if any, payable to him/her. On
//                                   being absorbed as an Employee of Employer,
//                                   after completion of the said period, Employer
//                                   would be entitled to terminate the services of
//                                   the Employee with Three Calendar Months’
//                                   written notice during the tenure of the
//                                   service agreement.
//                                 </p>
//                                 <p>
//                                   The provisions stated herein for breach by
//                                   Employee of the provisions of this agreement
//                                   shall be without prejudice to other remedies
//                                   available to Employer. In case of any dispute
//                                   arising out of the Agreement, it shall be
//                                   subject to the jurisdiction of the appropriate
//                                   Court of Hyderabad, Telangana, India.
//                                 </p>
//                               </>
//                             )}

//                             {currentPage1 === 2 && (
//                               <>
//                                 <Typography
//                                   sx={{
//                                     letterSpacing: "0.5px",
//                                     fontSize: "20px",
//                                     fontWeight: "bold",
//                                   }}
//                                 >
//                                   IN WITNESS WHEREOF, THIS AGREEMENT TO BE
//                                   EXECUTED AS DATE FIRST MENTIONED ABOVE.
//                                 </Typography>

//                                 <Typography
//                                   sx={{
//                                     letterSpacing: "0.2px",
//                                     textAlign: "justify",
//                                     mt: 1,
//                                   }}
//                                 >
//                                   I solely accept to submit my original
//                                   documents & Bank Cheques for the period of my
//                                   employment with the company. The company or
//                                   any individual has never forced or mandated me
//                                   to submit them, but it is limited to security
//                                   towards my agreed service tenure with the
//                                   company.
//                                 </Typography>

//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     justifyContent: "center",
//                                     mt: 0,
//                                   }}
//                                 >
//                                   <FormControlLabel
//                                     control={
//                                       <Checkbox
//                                         checked={checked}
//                                         onChange={handleChangeC}
//                                       />
//                                     }
//                                     label="Terms & Conditions"
//                                   />
//                                 </Box>

//                                 <h2
//                                   style={{ fontSize: "18px" }}
//                                   className="text-center text-lg font-bold underline mb-1"
//                                 >
//                                   NON-DISCLOSURE AGREEMENT
//                                 </h2>

//                                 <p className="text-justify mb-1">
//                                   THIS AGREEMENT made at Hyderabad on{" "}
//                                   <span className="font-bold">
//                                     {data?.unit}
//                                   </span>{" "}
//                                   day of{" "}
//                                   <span className="font-bold">
//                                     {data?.monthName}
//                                   </span>
//                                   , Two thousand and{" "}
//                                   <span className="font-bold">
//                                     {data?.date?.[2]}
//                                   </span>
//                                   .
//                                 </p>
//                                 <p className="text-justify mb-1">
//                                   This is to certify that I, Mr./Ms{" "}
//                                   <span className="font-bold">
//                                     {data?.employeeName}
//                                   </span>{" "}
//                                   have joined ENVISION INTEGRATED SERVICES
//                                   PRIVATE LIMITED and executed an agreement on{" "}
//                                   <span className="font-bold">
//                                     {data?.agreementDate}
//                                   </span>
//                                   .
//                                 </p>
//                                 <h3
//                                   style={{ fontSize: "18px" }}
//                                   className="text-center text-lg font-bold underline mb-1"
//                                 >
//                                   I HEREBY GIVE THE FOLLOWING UNDERTAKING:
//                                 </h3>
//                                 <ul className="list-decimal pl-6 text-justify space-y-2">
//                                   <li>
//                                     I am not involved in any civil/criminal
//                                     cases, proceedings, charges, or enquiry
//                                     before joining Envision Integrated Services
//                                     Pvt. Ltd.
//                                   </li>
//                                   <li>
//                                     I am not involved in any disciplinary
//                                     actions or malpractices before joining
//                                     Envision Integrated Services Pvt. Ltd.
//                                   </li>
//                                   <li>
//                                     I was not employed gainfully or on an
//                                     honorary basis in any organization before
//                                     joining Envision Integrated Services Pvt.
//                                     Ltd.
//                                   </li>
//                                   <li>
//                                     I will protect confidential information and
//                                     will not share it without proper
//                                     authorization.
//                                   </li>
//                                   <li>
//                                     Any unintentional breach of this policy will
//                                     be investigated and may be punished
//                                     appropriately.
//                                   </li>
//                                   <li>
//                                     I will abide by all company policies, rules,
//                                     and regulations currently prevailing or
//                                     established in the future.
//                                   </li>
//                                   <li>
//                                     I will not approach any of the company’s
//                                     clients, vendors, or associates for two
//                                     years after termination/resignation.
//                                   </li>
//                                   <li>
//                                     The company may terminate this agreement
//                                     with one month’s notice if I:
//                                     <ul className="list-disc pl-6">
//                                       <li>
//                                         Commit any material or persistent breach
//                                         of provisions.
//                                       </li>
//                                       <li>
//                                         Am guilty of any misconduct or neglect
//                                         affecting the company’s business.
//                                       </li>
//                                     </ul>
//                                   </li>
//                                   <li>
//                                     I shall keep all proprietary information
//                                     confidential in accordance with the NDA.
//                                   </li>
//                                   <li>
//                                     If any statement in this agreement is found
//                                     false, the company has the right to
//                                     terminate my services and take legal action.
//                                   </li>
//                                   <li>
//                                     I will indemnify and protect the company
//                                     from any loss or liability caused by my
//                                     actions.
//                                   </li>
//                                   <li>
//                                     I affirm that all the above statements are
//                                     true to my knowledge and belief.
//                                   </li>
//                                 </ul>

//                                 <div className="row">
//                                   <div className="col">
//                                     <br />
//                                     Name of the Employe:{" "}
//                                     <span style={{ fontWeight: "bold" }}>
//                                       {data?.employeeName}
//                                     </span>
//                                   </div>
//                                   <div
//                                     className="col"
//                                     style={{ marginTop: "17px" }}
//                                   >
//                                     Date:{" "}
//                                     <span style={{ fontWeight: "bold" }}>
//                                       {data.agreementDate}
//                                     </span>
//                                   </div>

//                                   <div
//                                     style={{ marginTop: "10px" }}
//                                     className="row"
//                                   >
//                                     <div className="col">
//                                       {!signature ? (
//                                         <>
//                                           <span>Signature: </span>
//                                           <input
//                                             type="file"
//                                             onChange={selectFileSign2}
//                                           />
//                                           <br />
//                                           <small>JPEG/PNG/JPG</small>
//                                           <br />
//                                           <small>
//                                             (Upload File Size: 1 MB - 2 MB)
//                                           </small>
//                                         </>
//                                       ) : (
//                                         <div style={{ marginTop: "-30px" }}>
//                                           <div
//                                             style={{
//                                               marginRight: "121px",
//                                             }}
//                                           >
//                                             <img
//                                               src={`data:image/jpg;base64,${bytecodeimage2}`}
//                                               alt="Signature"
//                                               style={{
//                                                 height: "100px",
//                                                 marginTop: "-20px",
//                                                 marginLeft: "10px",
//                                                 width: "180px",
//                                               }}
//                                             />
//                                             <span
//                                               style={{
//                                                 marginLeft: "0px",
//                                                 marginBottom: "56px",
//                                                 cursor: "pointer",
//                                                 color: "red",
//                                               }}
//                                               onClick={closeImage}
//                                             >
//                                               ❌
//                                             </span>
//                                           </div>
//                                         </div>
//                                       )}
//                                     </div>
//                                     <div
//                                       style={{
//                                         marginLeft: "370px",
//                                         marginTop: "-85px",
//                                       }}
//                                       className="col"
//                                     >
//                                       {!signature ? (
//                                         <>
//                                           <span
//                                             style={{
//                                               display: "inline-block",
//                                               minWidth: "auto",
//                                               marginRight: "0px",
//                                             }}
//                                           >
//                                             Left Hand Thumb Impression:
//                                           </span>
//                                           <input
//                                             type="file"
//                                             onChange={selectFileSign2}
//                                           />
//                                           <br />
//                                           <small>JPEG/PNG/JPG</small>
//                                           <br />
//                                           <small>
//                                             (Upload File Size: 1 MB - 2 MB)
//                                           </small>
//                                         </>
//                                       ) : (
//                                         <div style={{ marginTop: "-30px" }}>
//                                           <div
//                                             style={{
//                                               marginRight: "121px",
//                                             }}
//                                           >
//                                             <img
//                                               src={`data:image/jpg;base64,${bytecodeimage2}`}
//                                               alt="Signature"
//                                               style={{
//                                                 height: "100px",
//                                                 marginTop: "-20px",
//                                                 marginLeft: "10px",
//                                                 width: "180px",
//                                               }}
//                                             />
//                                             <span
//                                               style={{
//                                                 marginLeft: "0px",
//                                                 marginBottom: "56px",
//                                                 cursor: "pointer",
//                                                 color: "red",
//                                               }}
//                                               onClick={closeImage}
//                                             >
//                                               ❌
//                                             </span>
//                                           </div>
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </>
//                             )}
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                     <div
//                       style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         marginTop: "20px",
//                         marginBottom: "20px",
//                       }}
//                     >
//                       {/* Previous Button */}
//                       <button
//                         onClick={() => {
//                           handlePrev();
//                           setTimeout(() => {
//                             document.getElementById("top")?.scrollIntoView({
//                               behavior: "smooth",
//                               block: "start",
//                             });
//                           }, 100);
//                         }}
//                         disabled={startPage === 1}
//                         style={{
//                           padding: "10px 15px",
//                           margin: "5px",
//                           cursor: startPage === 1 ? "not-allowed" : "pointer",
//                           backgroundColor: startPage === 1 ? "#ddd" : "#007bff",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "5px",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         Prev
//                       </button>

//                       {/* Page Numbers (Only 3 Visible at a Time) */}
//                       {[...Array(pageLimit1)].map((_, index) => {
//                         const pageNumber = startPage + index;
//                         if (pageNumber > totalPages1) return null;

//                         return (
//                           <button
//                             key={pageNumber}
//                             onClick={() => {
//                               setCurrentPage1(pageNumber);
//                               setTimeout(() => {
//                                 document.getElementById("top")?.scrollIntoView({
//                                   behavior: "smooth",
//                                   block: "start",
//                                 });
//                               }, 100);
//                             }}
//                             style={{
//                               padding: "10px 15px",
//                               margin: "5px",
//                               cursor: "pointer",
//                               backgroundColor:
//                                 pageNumber === currentPage1
//                                   ? "#007bff"
//                                   : "#f0f0f0",
//                               color:
//                                 pageNumber === currentPage1 ? "white" : "black",
//                               border: "none",
//                               borderRadius: "5px",
//                               fontWeight: "bold",
//                             }}
//                           >
//                             {pageNumber}
//                           </button>
//                         );
//                       })}

//                       {/* Next Button */}
//                       <button
//                         onClick={() => {
//                           handleNext();
//                           setTimeout(() => {
//                             document.getElementById("top")?.scrollIntoView({
//                               behavior: "smooth",
//                               block: "start",
//                             });
//                           }, 100);
//                         }}
//                         disabled={startPage + pageLimit1 > totalPages1}
//                         style={{
//                           padding: "10px 15px",
//                           margin: "5px",
//                           cursor:
//                             startPage + pageLimit1 > totalPages1
//                               ? "not-allowed"
//                               : "pointer",
//                           backgroundColor:
//                             startPage + pageLimit1 > totalPages1
//                               ? "#ddd"
//                               : "#007bff",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "5px",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         Next
//                       </button>
//                     </div>
//                   </DialogContent>
//                 </Dialog>

//                 <Dialog
//                   sx={{
//                     "& .MuiDialog-paper": {
//                       minHeight: "70vh", // Ensure dialog is tall
//                       maxHeight: "70vh",
//                     },
//                   }}
//                   style={{ marginTop: "-40px", marginLeft: "8%" }}
//                   open={openVW}
//                   onClose={() => setOpenE(false)}
//                   maxWidth="md"
//                   fullWidth
//                 >
//                   <DialogTitle>
//                     HandBook
//                     <IconButton
//                       onClick={() => setOpenVW(false)}
//                       sx={{ position: "absolute", right: 10, top: 10 }}
//                     >
//                       <Close color="error" />
//                     </IconButton>
//                   </DialogTitle>
//                   <DialogContent>
//                     <Box
//                       sx={{
//                         maxHeight: "400px",
//                         overflowY: "auto",
//                         padding: 2,
//                       }}
//                     >
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           alignItems: "center",
//                           minHeight: "100vh",
//                         }}
//                       >
//                         <div
//                           id="top"
//                           style={{
//                             width: "210mm", // A4 width
//                             height: "297mm", // A4 height
//                             backgroundColor: "white", // Background color of the page
//                             padding: "20mm", // Ensuring proper spacing
//                             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", // Optional: Adding a slight shadow
//                             overflow: "hidden",
//                             borderRadius: "5px",
//                           }}
//                         >
//                           {currentPage === 1 && (
//                             <div className="page1 page_1">
//                               <div style={{ display: "flex" }}>
//                                 <div>
//                                   <p
//                                     style={{
//                                       color: "orange",
//                                       fontSize: "80px",
//                                       paddingTop: "20px",
//                                       paddingLeft: "80px",
//                                     }}
//                                   >
//                                     EMPLOYEE
//                                   </p>
//                                   <p
//                                     style={{
//                                       color: "blue",
//                                       paddingTop: "40px",
//                                       fontSize: "75px",
//                                       paddingLeft: "80px",
//                                     }}
//                                   >
//                                     HANDBOOK
//                                   </p>
//                                 </div>
//                                 <div>
//                                   <p
//                                     style={{
//                                       paddingTop: "180px",
//                                       transform: "rotate(270deg)",
//                                       fontSize: "40px",
//                                       fontWeight: "bold",
//                                     }}
//                                   >
//                                     FY 24-25
//                                   </p>
//                                 </div>
//                               </div>
//                               <img
//                                 src={layoutImage}
//                                 alt="Layout"
//                                 style={{
//                                   paddingTop: "20px",
//                                   height: "300px",
//                                   width: "100%",
//                                 }}
//                               />
//                               <p
//                                 style={{
//                                   fontSize: "30px",
//                                   paddingTop: "10px",
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                 }}
//                               >
//                                 OUR CORE OPERATING VALUES
//                               </p>
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   paddingTop: "70px",
//                                 }}
//                               >
//                                 <p
//                                   style={{
//                                     fontSize: "30px",
//                                     color: "blue",
//                                     paddingLeft: "80px",
//                                   }}
//                                 >
//                                   01
//                                 </p>
//                                 <p style={{ paddingLeft: "10px" }}>
//                                   Personal Responsibility and Accountability
//                                 </p>
//                               </div>
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   paddingTop: "30px",
//                                 }}
//                               >
//                                 <p
//                                   style={{
//                                     fontSize: "30px",
//                                     color: "yellow",
//                                     paddingLeft: "150px",
//                                   }}
//                                 >
//                                   02
//                                 </p>
//                                 <p style={{ paddingLeft: "10px" }}>
//                                   Promoting Teamwork and Collaboration
//                                 </p>
//                               </div>
//                               <div
//                                 style={{
//                                   display: "flex",
//                                   paddingTop: "30px",
//                                 }}
//                               >
//                                 <p
//                                   style={{
//                                     fontSize: "30px",
//                                     color: "orangered",
//                                     paddingLeft: "200px",
//                                   }}
//                                 >
//                                   03
//                                 </p>
//                                 <p style={{ paddingLeft: "10px" }}>
//                                   Use good Judgment in all situations
//                                 </p>
//                               </div>
//                             </div>
//                           )}

//                           {currentPage === 2 && (
//                             <div className="page page_2" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-15%",
//                                 }}
//                               />
//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 VISION
//                               </h1>
//                               <p style={{ textAlign: "justify" }}>
//                                 Envision IS Group is to become the best,
//                                 end-to-end Consulting, Technology and
//                                 Engineering Solution partner in Global
//                                 Engineering Services domains by making a
//                                 difference to society through creation of value.
//                               </p>
//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 VALUES AND BELIEFS
//                               </h1>
//                               <ol
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   <b>Humility:</b> We value intellectual modesty
//                                   and detest false pride and arrogance.
//                                 </li>
//                                 <li>
//                                   <b>Entrepreneurship:</b> We seek opportunities
//                                   – they are everywhere.
//                                 </li>
//                                 <li>
//                                   <b>Teamwork and Relationships:</b> Going
//                                   beyond the individual, encouraging
//                                   boundary-less behavior.
//                                 </li>
//                                 <li>
//                                   <b>Deliver the Promise:</b> We value
//                                   responsibility and self-discipline, to meet
//                                   and surpass commitments made.
//                                 </li>
//                                 <li>
//                                   <b>Learning and Inner Excellence:</b> We
//                                   cherish the lifelong commitment to deepen
//                                   self-awareness, explore, experiment, and
//                                   improve our potential.
//                                 </li>
//                                 <li>
//                                   <b>Social Responsibility:</b> Anticipating and
//                                   meeting relevant and emerging needs of
//                                   society.
//                                 </li>
//                                 <li>
//                                   <b>Respect for Individual:</b> We will treat
//                                   others with dignity, sensitivity, and honor.
//                                 </li>
//                               </ol>
//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 FOREWORD
//                               </h1>
//                               <p style={{ textAlign: "justify" }}>
//                                 Dear Colleague,
//                                 <br />
//                                 <br />
//                                 It is indeed a privilege to have you as a member
//                                 of our Envision family.
//                                 <br />
//                                 <br />
//                                 It gives us immense pleasure to share this
//                                 booklet containing the essence of our HR
//                                 Policies. It provides us with an opportunity to
//                                 learn about our various HR policies and enhance
//                                 our understanding of these policies.
//                                 <br />
//                                 <br />
//                                 We are sure that this booklet will make it easy
//                                 for you to refer to these policies instead of
//                                 relying on memory.
//                                 <br />
//                                 <br />
//                                 Happy reading!!
//                               </p>
//                               <h1
//                                 style={{
//                                   textAlign: "left",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 Manager – HR
//                               </h1>
//                               <p style={{ fontSize: "15px" }}>
//                                 Note: Policy & Processes are subject to change,
//                                 for detailed & regular policy updates please
//                                 reach HR.
//                               </p>
//                             </div>
//                           )}

//                           {currentPage === 3 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   marginTop: "10px",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 THE COMPANY
//                               </h1>

//                               <p style={{ textAlign: "justify" }}>
//                                 Envision IS Group is an IT & ITES Solutions
//                                 Provider. Envision IS excels in diversified
//                                 sectors like Engineering, Automotive,
//                                 Manufacturing, Industrial automation,
//                                 Information Technology, and Staffing. With
//                                 significant experience in the development of
//                                 critical applications, we have mastered the
//                                 craft of blending technology and business. We
//                                 specialize in a range of technologies including
//                                 CAD, CAM, CAE, Java, .NET, C/C++, and much more,
//                                 providing solutions across various industries.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 Envision IS provides development services
//                                 worldwide. A team of industry and technology
//                                 specialists with extensive experience as both
//                                 providers and customers of development heads the
//                                 facility. With our rich knowledge base, our
//                                 extensive supply of coded modules, and our
//                                 documented best practices for each technology
//                                 area, we can deliver high-quality solutions in a
//                                 timely manner. Our integrated solutions are
//                                 based on robust business principles and are
//                                 committed to your business growth. These
//                                 solutions go hand in hand with your changing
//                                 business needs.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 Technology is a key ingredient of business
//                                 growth. We at Envision IS have mastered the
//                                 craft of blending technology and business. Our
//                                 solutions are woven around your business needs
//                                 and leverage our existing IT investment to
//                                 realize quicker returns.
//                               </p>

//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 ABOUT THE HANDBOOK
//                               </h1>

//                               <p style={{ textAlign: "justify" }}>
//                                 This Envision IS Employee Handbook establishes
//                                 policies, procedures, benefits, and a working
//                                 environment that will be followed by all
//                                 Envision IS Employees as a condition of their
//                                 employment at the company. The standards of
//                                 conduct describe the expected actions and
//                                 behaviors of employees while conducting company
//                                 business.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 The policies and procedures outlined in this
//                                 handbook will be applied at the discretion of
//                                 Envision IS. Envision IS reserves the right to
//                                 change the policies, procedures, and benefits
//                                 from time to time for the betterment of the
//                                 organization. The company will make every effort
//                                 to notify employees when an official change in
//                                 policy or procedure has been made.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 No provisions in this employee handbook and
//                                 expected standards of conduct can be waived
//                                 without written permission from the company's
//                                 president or designee. Such a waiver, if
//                                 granted, applies only to the employee for whom
//                                 the waiver was granted at the time of the
//                                 waiver.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 Envision IS strives to provide an
//                                 employee-friendly environment in which
//                                 goal-oriented individuals thrive as they achieve
//                                 ever more demanding challenges. Our company
//                                 commitment to serving customers and providing
//                                 quality products at competitive prices is
//                                 unwavering. These policies, procedures, and
//                                 working environments provide a work environment
//                                 in which both customer interests and employee
//                                 interests are served.
//                               </p>
//                             </div>
//                           )}

//                           {currentPage === 4 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <p
//                                 style={{
//                                   textAlign: "justify",
//                                   marginTop: "10px",
//                                 }}
//                               >
//                                 Envision IS values the talents and abilities of
//                                 our employees and seeks to foster an open,
//                                 cooperative, and dynamic environment in which
//                                 employees and the company alike can thrive. The
//                                 company provides an open-door policy in which
//                                 employees are encouraged to take problems to the
//                                 next level of management if they are unable to
//                                 resolve a situation with their direct
//                                 supervisor.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 Envision IS is an equal opportunity employer.
//                                 Religion, age, gender, national origin, sexual
//                                 orientation, race, or color does not affect
//                                 hiring, promotion, development opportunities,
//                                 pay, or benefits. Envision IS provides for fair
//                                 treatment of employees based on merit. The
//                                 company complies with all applicable central
//                                 state, and local labor laws.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 Employment at Envision IS is on an "at will"
//                                 basis, which means that either you (the
//                                 employee) or Envision IS may terminate the
//                                 employment relationship at any time, for any
//                                 reason, with or without cause. Only a written
//                                 agreement, signed by the authorized person of
//                                 Envision IS, can change the "at will" nature of
//                                 the employment of any individual.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 You will be asked to affirm that you have read,
//                                 understand, agree to abide by, and acknowledge
//                                 your receipt of this employee handbook and
//                                 employee standards of conduct.
//                               </p>

//                               <ul
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   As an employee of Envision IS, this handbook
//                                   is to help you understand the system you work
//                                   for by providing an overview of important
//                                   rights, policies and benefits you have as an
//                                   employee of envision IS. Though this Handbook
//                                   is not intended to cover all the policies and
//                                   procedures in great detail; for more detailed
//                                   questions, contact the HR Department.
//                                 </li>
//                                 <li>
//                                   This handbook applies to all employees who are
//                                   in permanent, probationary and trainee
//                                   appointments.
//                                 </li>
//                               </ul>

//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 MESSAGE FROM CEO
//                               </h1>
//                               <h1
//                                 style={{
//                                   textAlign: "left",
//                                   fontWeight: "bold",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Greetings to Employee!
//                               </h1>

//                               <p style={{ textAlign: "justify" }}>
//                                 We believe that each employee contributes
//                                 directly to the company’s growth and success,
//                                 and we hope you will take pride in being a
//                                 member of our Team.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 This handbook is designed to acquaint you with
//                                 the company and to provide you with information
//                                 about working environment, employee benefits,
//                                 and some of the policies affecting your
//                                 employment. You should read, understand, and
//                                 comply with all provisions of the handbook. It
//                                 describes many of your responsibilities as an
//                                 employee and outlines the programs developed by
//                                 the company to benefit the employees. One of our
//                                 objectives is to provide a work environment that
//                                 is conductive to both personal and professional
//                                 growth.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 As the business continues to grow, the need may
//                                 arise to change policies described in the
//                                 handbook. The company therefore reserves the
//                                 right to revise, supplement, or rescind any
//                                 policies or portion of the handbook from time to
//                                 time as it deems appropriate, in its sole and
//                                 absolute discretion, employees will, of course,
//                                 be notified of such changes as they occur.
//                               </p>
//                             </div>
//                           )}

//                           {currentPage === 5 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <p style={{ textAlign: "justify" }}>
//                                 We hope that your experience here will be
//                                 challenging, enjoyable, and rewarding. Again,
//                                 welcome!
//                               </p>

//                               <h1
//                                 style={{
//                                   textAlign: "left",
//                                   fontWeight: "bold",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Sincerely
//                               </h1>

//                               <h1
//                                 style={{
//                                   textAlign: "left",
//                                   fontWeight: "bold",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 Envision IS – CEO
//                               </h1>

//                               <h1
//                                 style={{
//                                   textAlign: "left",
//                                   fontWeight: "bold",
//                                   fontSize: "15px",
//                                 }}
//                               >
//                                 C Chandra Sekhar Reddy
//                               </h1>

//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   marginTop: "10px",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 JOB RESPONSIBILITY LEVEL (JRL)
//                               </h1>

//                               <p style={{ textAlign: "justify" }}>
//                                 All jobs in Envision Group are classified into 4
//                                 bands i.e. Direction, Integration, Managerial,
//                                 and Execution. There are two streams of job
//                                 roles in Envision Group: Managerial and
//                                 Specialist.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 The bands and grades have been arrived at
//                                 through a systematic process of Job Evaluation
//                                 (JE). It is a process of deriving the relative
//                                 worth of a job or role in an organization in a
//                                 fair and logical manner.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 JE takes into account organizational context and
//                                 complexities and evaluates the role based on Job
//                                 Description (JD) i.e. Know How, Problem Solving,
//                                 and Accountability. It’s applicable for all
//                                 regular employees.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>
//                                 <b>Managerial Grades and Bands:</b> The
//                                 managerial grades are predominantly
//                                 execution-focused roles in the organization.
//                               </p>

//                               <table
//                                 style={{
//                                   width: "100%",
//                                   borderCollapse: "collapse",
//                                   border: "1px solid black",
//                                 }}
//                               >
//                                 <thead>
//                                   <tr
//                                     style={{
//                                       textAlign: "center",
//                                       backgroundColor: "#f2f2f2",
//                                     }}
//                                   >
//                                     <th
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Band
//                                     </th>
//                                     <th
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Description
//                                     </th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <tr>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Direction
//                                     </td>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Roles driving and impacting the strategy,
//                                       overall top-line and bottom-line of the
//                                       entity. Cascading strategy into
//                                       functional/ sector level imperatives and
//                                       translating them into operative goals for
//                                       generating revenue/ supporting the
//                                       business.
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Integration
//                                     </td>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Full-fledged professionals who will be
//                                       heading verticals/ sub-verticals within
//                                       their sectors and will have proven
//                                       expertise and experience. Delivery of
//                                       results would be focused on sector/
//                                       functional goals.
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Managerial
//                                     </td>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Seasoned professionals who have deep
//                                       expertise in a particular function/ area
//                                       and will generally be leading /
//                                       accountable for specific areas of work
//                                       within the verticals/ sub-verticals.
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Execution
//                                     </td>
//                                     <td
//                                       style={{
//                                         border: "1px solid black",
//                                         padding: "8px",
//                                       }}
//                                     >
//                                       Supervising others / Individual
//                                       Contributor to achieve a common
//                                       department/ functional purpose.
//                                     </td>
//                                   </tr>
//                                 </tbody>
//                               </table>

//                               <br />

//                               <p style={{ textAlign: "justify" }}>
//                                 <b>Specialists Grades and Bands:</b> The
//                                 specialist grades are predominantly ‘domain’
//                                 focused roles. These roles are large in number
//                                 and require a high amount of know-how / deep
//                                 domain expertise. These roles are classified
//                                 based on the ‘Know How’ part of the JE.
//                               </p>
//                             </div>
//                           )}
//                           {currentPage === 6 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <table className="w-full mt-2 border-collapse border border-gray-400">
//                                 <thead>
//                                   <tr className="text-center bg-gray-200">
//                                     <th className="border border-gray-400 p-2">
//                                       Band
//                                     </th>
//                                     <th className="border border-gray-400 p-2">
//                                       Description
//                                     </th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <tr>
//                                     <td className="border border-gray-400 p-2">
//                                       Direction
//                                     </td>
//                                     <td className="border border-gray-400 p-2 text-justify">
//                                       <ul className="mr-5 list-disc pl-5">
//                                         <li>
//                                           Job demands advanced knowledge of a
//                                           specialized technical division which
//                                           is deployed in the analysis and
//                                           resolution of problems and the
//                                           provision of specialist advice that
//                                           would have a group/sector-wide impact.
//                                         </li>
//                                         <li>
//                                           Jobs at this level require leading a
//                                           department/business unit (typically
//                                           integrating a number of small
//                                           technical/professional teams) thereby
//                                           requiring understanding of all related
//                                           technical disciplines within that
//                                           department/BU (Business Unit).
//                                         </li>
//                                       </ul>
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <td className="border border-gray-400 p-2">
//                                       Integration
//                                     </td>
//                                     <td className="border border-gray-400 p-2 text-justify">
//                                       <ul className="mr-5 list-disc pl-5">
//                                         <li>
//                                           Jobs at this level would require
//                                           in-depth understanding of the
//                                           technical discipline and will tend to
//                                           be heads of specialist functions
//                                           within a sector.
//                                         </li>
//                                         <li>
//                                           Jobs in this level are responsible for
//                                           leading specialist teams in a
//                                           technical discipline which must
//                                           deliver specific, measurable
//                                           objectives through the management and
//                                           coordination of internal resources or
//                                           the development of relationships and
//                                           coordination with external partners.
//                                         </li>
//                                       </ul>
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <td className="border border-gray-400 p-2">
//                                       Managerial
//                                     </td>
//                                     <td className="border border-gray-400 p-2 text-justify">
//                                       <ul className="mr-5 list-disc pl-5">
//                                         <li>
//                                           The job is primarily accountable for
//                                           implementing and adapting work plans
//                                           in light of operational events.
//                                         </li>
//                                         <li>
//                                           Jobs in this level are recognized for
//                                           providing practical
//                                           solutions/implementation options based
//                                           on know-how gathered from extensive
//                                           applied experience.
//                                         </li>
//                                         <li>
//                                           Jobs at this level provide technical
//                                           analysis and support within a specific
//                                           sub-function of the business.
//                                         </li>
//                                         <li>
//                                           Roles at this level develop expertise
//                                           through a combination of direct
//                                           relevant technical training and job
//                                           experience under the guidance of
//                                           specialists.
//                                         </li>
//                                       </ul>
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <td className="border border-gray-400 p-2">
//                                       Execution
//                                     </td>
//                                     <td className="border border-gray-400 p-2 text-justify">
//                                       <ul className="mr-5 list-disc pl-5">
//                                         <li>
//                                           Jobs at this level provide specialist
//                                           technical support and service within a
//                                           business/company/project. Undertakes
//                                           specific technical/support tasks of
//                                           varying complexity.
//                                         </li>
//                                         <li>
//                                           These jobs select and use appropriate
//                                           procedures, equipment, and techniques
//                                           to analyze and interpret data and
//                                           produce required technical outputs.
//                                         </li>
//                                       </ul>
//                                     </td>
//                                   </tr>
//                                 </tbody>
//                               </table>
//                             </div>
//                           )}
//                           {currentPage === 7 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <table className="w-full mt-2 border border-gray-300">
//                                 <tbody>
//                                   <tr className="border">
//                                     <td className="p-2 font-bold">Execution</td>
//                                     <td className="p-2 text-justify">
//                                       <ul className="list-disc ml-5">
//                                         <li>
//                                           Participate as part of a team to
//                                           implement projects, occasionally
//                                           providing technical leadership to
//                                           junior colleagues. Jobs in this level
//                                           are typically supervisor/individual
//                                           contributors who have experience
//                                           working within the area and are now
//                                           developing deeper expertise in the
//                                           same.
//                                         </li>
//                                       </ul>
//                                     </td>
//                                   </tr>
//                                 </tbody>
//                               </table>

//                               <h1 className="text-center font-bold text-lg mt-4">
//                                 EMPLOYMENT
//                               </h1>

//                               <ol className="list-decimal ml-5 text-justify mt-2">
//                                 <li>
//                                   <b>Appointment:</b> Your appointment is based
//                                   on your performance in the recruitment process
//                                   of our Company. Your appointment is subject to
//                                   the terms and conditions mentioned in the
//                                   Appointment Letter given to you. You need to
//                                   give your acceptance by signing and returning
//                                   the duplicate copy of the Appointment Letter
//                                   to the HR department. Your Signing the
//                                   Appointment Letter implies that you agree to
//                                   the terms and conditions mentioned in the
//                                   Appointment Letter.
//                                 </li>

//                                 <li className="mt-3">
//                                   <b>Probationary or Trainee Period:</b> The
//                                   probationary period serves as an extension of
//                                   the Selection process and gives both you and
//                                   your supervisor time to see if the job is
//                                   right for you, and you are right for the job.
//                                   As per the Company standards, you will be on
//                                   probation or trainee for a period of 3-6
//                                   months from the date of joining and may be
//                                   confirmed by HR as a permanent employee upon
//                                   successful completion of your probation.
//                                 </li>
//                               </ol>

//                               <ul className="list-disc ml-8 text-justify mt-2">
//                                 <li>
//                                   If you demonstrate satisfactory work progress
//                                   during the Probationary Period and the
//                                   decision is made to continue your employment,
//                                   you will receive a permanent Appointment
//                                   Letter. If work progress is not satisfactory,
//                                   an employee can be terminated with an
//                                   opportunity for appeal at management’s
//                                   discretion.
//                                 </li>
//                                 <li>
//                                   Any employee who newly joined the organization
//                                   should not take any leaves within 3 months
//                                   from their joining date.
//                                 </li>
//                                 <li>
//                                   If any Employee takes leaves during the
//                                   initial 3 months, it will be considered as LOP
//                                   (Loss of Pay). Refer: Leave Policy from HR.
//                                 </li>
//                                 <li>
//                                   After the completion of the 3-month
//                                   Probationary period, respective leaves will be
//                                   credited to the Employee account on a pro-rata
//                                   basis.
//                                 </li>
//                               </ul>

//                               <p className="text-justify mt-4">
//                                 <b>Work Schedule:</b> The standard workweek
//                                 schedule is 6 days per week, eight hours a day
//                                 plus a one-hour meal period. Other schedules
//                                 apply to some shift employees. The Company also
//                                 has a Flexible Work Schedule. The employee and
//                                 the supervisor shall agree upon a Variable Work
//                                 Schedule consistent with the needs of the
//                                 Company.
//                               </p>
//                             </div>
//                           )}

//                           {currentPage === 8 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <p className="font-semibold">
//                                 The following general rules apply to the
//                                 Flexible Work Schedule:
//                               </p>
//                               <ul className="ml-5 list-disc">
//                                 <li>
//                                   An employee, who arrives later than scheduled
//                                   time, may be permitted to make up the deficit
//                                   by working that much longer at the end of the
//                                   workday according to the work needs of the
//                                   Company. Otherwise, the tardiness shall be
//                                   charged to the appropriate leave category.
//                                   Team Leaders shall take appropriate action to
//                                   correct any abuse or misuse of this privilege
//                                   which may include deductions from employee’s
//                                   pay.
//                                 </li>
//                                 <li>
//                                   If an employee reports to work early, the
//                                   employee may, with the supervisor’s
//                                   permission, begin work at that time and leave
//                                   at a correspondingly early hour.
//                                 </li>
//                                 <li>
//                                   Employee must be self-responsible for Web
//                                   clock-in and Web clock-out. Missing the
//                                   login-logout will yield your day as LOP. No
//                                   attendance regularization will be considered.
//                                 </li>
//                                 <li>
//                                   If an employee leaves work early without
//                                   permission, the time shall be:
//                                   <ul className="ml-5 list-disc">
//                                     <li>
//                                       Deducted from the employee’s pay or may be
//                                       charged to the appropriate leave account
//                                       if justified.
//                                     </li>
//                                   </ul>
//                                 </li>
//                               </ul>

//                               <p className="mt-4">
//                                 <span className="font-bold">
//                                   4. Work Behavior:
//                                 </span>{" "}
//                                 It is essential that all employees accept
//                                 personal responsibility for maintaining high
//                                 standards of conduct and job performance,
//                                 including observance of the Company rules and
//                                 policies. Violations of these standards will
//                                 result in disciplinary action.
//                               </p>
//                               <p>
//                                 Disciplinary action is considered a dimension of
//                                 performance evaluation. It is a corrective
//                                 process to help employees overcome work-related
//                                 shortcomings, strengthen work performance, and
//                                 achieve success.
//                               </p>

//                               <p className="mt-4">
//                                 <span className="font-bold">
//                                   5. Performance Expectations:
//                                 </span>{" "}
//                                 At the time of joining, you will be given a copy
//                                 of your Job Description along with a set of
//                                 expectations that the Company is looking for in
//                                 you. These expectations will be made in
//                                 consultation with you. Depending upon the need
//                                 of the hour and your position, the expectations
//                                 will vary, which will be communicated.
//                               </p>
//                               <p>
//                                 Goals have a Weightage of 100%. Annual Goals and
//                                 individual Weightages are to be discussed
//                                 between the Appraiser and the Appraisee and
//                                 signed off at the beginning of the year.
//                               </p>
//                               <ul className="ml-5 list-disc">
//                                 <li>
//                                   Description of Goals: To be in line with the
//                                   annual Goal Sheet.
//                                 </li>
//                                 <li>
//                                   Planned Target: Each Goal to be quantified for
//                                   measurement, with a timeline for completion.
//                                 </li>
//                                 <li>
//                                   Weightage Score: Each Goal needs to have a
//                                   relative Weightage score based on its
//                                   importance to the Appraisee's overall
//                                   performance.
//                                 </li>
//                                 <li>Rating Scale:</li>
//                                 <ul className="ml-5 list-disc">
//                                   <li>OP – Outstanding Performer</li>
//                                   <li>EP – Exceeding Performer</li>
//                                   <li>VGP – Very Good Performer</li>
//                                 </ul>
//                               </ul>
//                             </div>
//                           )}
//                           {currentPage === 9 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <h2 style={{ fontSize: "18px" }}>
//                                 Flexible Work Schedule
//                               </h2>
//                               <ul className="list-disc ml-6">
//                                 <li>
//                                   An employee arriving late may make up the
//                                   deficit by working longer, subject to company
//                                   needs. Otherwise, tardiness will be deducted
//                                   from leave. Misuse may result in pay
//                                   deductions.
//                                 </li>
//                                 <li>
//                                   Employees arriving early may start work with
//                                   supervisor’s permission and leave early
//                                   accordingly.
//                                 </li>
//                                 <li>
//                                   Employees are responsible for Web
//                                   clock-in/out. Missing login/logout results in
//                                   LOP with no attendance regularization.
//                                 </li>
//                                 <li>
//                                   Leaving work early without permission results
//                                   in:
//                                   <ul className="list-disc ml-6">
//                                     <li>Deduction from pay.</li>
//                                     <li>Charge to leave if justified.</li>
//                                   </ul>
//                                 </li>
//                               </ul>

//                               <h2
//                                 style={{ fontSize: "18px" }}
//                                 className="text-xl font-bold mt-6"
//                               >
//                                 Work Behavior
//                               </h2>
//                               <p>
//                                 Employees must maintain high standards of
//                                 conduct and job performance. Violations will
//                                 lead to disciplinary action.
//                               </p>
//                               <p>
//                                 Disciplinary actions help employees overcome
//                                 shortcomings, improve performance, and succeed.
//                               </p>

//                               <h2
//                                 style={{ fontSize: "18px" }}
//                                 className="text-xl font-bold mt-6"
//                               >
//                                 Performance Expectations
//                               </h2>
//                               <p>
//                                 Employees receive a Job Description and
//                                 expectations upon joining. These expectations
//                                 may vary based on role and will be communicated.
//                               </p>
//                               <p>
//                                 Goals have a 100% weightage, discussed and
//                                 signed off at the beginning of the year.
//                               </p>
//                               <ul className="list-disc ml-6">
//                                 <li>Goals align with the annual Goal Sheet.</li>
//                                 <li>
//                                   Each goal is quantified with a timeline for
//                                   completion.
//                                 </li>
//                                 <li>
//                                   Each goal has a weightage score for
//                                   performance evaluation.
//                                 </li>
//                                 <li>
//                                   Rating Scale:
//                                   <ul className="list-disc ml-6">
//                                     <li>OP – Outstanding Performer</li>
//                                     <li>EP – Exceeding Performer</li>
//                                     <li>VGP – Very Good Performer</li>
//                                     <li>NP – Non Performer</li>
//                                   </ul>
//                                 </li>
//                               </ul>

//                               <h2
//                                 style={{ fontSize: "18px" }}
//                                 className="text-xl font-bold mt-6"
//                               >
//                                 Performance Evaluation
//                               </h2>
//                               <p>
//                                 Annual Performance Evaluation is conducted
//                                 yearly. Self-Appraisal forms must be filled by
//                                 employees and submitted to HR. The process
//                                 involves:
//                               </p>
//                             </div>
//                           )}
//                           {currentPage === 10 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <h3 className="font-semibold mt-4">
//                                 Immediate Supervisor Responsibilities:
//                               </h3>
//                               <ul className="list-disc ml-6">
//                                 <li>
//                                   Complete evaluation promptly and discuss
//                                   exceptional cases.
//                                 </li>
//                                 <li>
//                                   Discuss strengths and weaknesses with
//                                   employees, set mutual goals.
//                                 </li>
//                                 <li>
//                                   Allow employees to add comments and sign the
//                                   form.
//                                 </li>
//                                 <li>
//                                   Forward the form to HR and retain copies.
//                                 </li>
//                                 <li>
//                                   If changes are made post-signing, notify the
//                                   supervisor and employee with revised copies.
//                                 </li>
//                               </ul>
//                               <h3 className="font-semibold mt-4">
//                                 Manager Responsibilities:
//                               </h3>
//                               <ul className="list-disc ml-6">
//                                 <li>
//                                   Review forms and ensure further actions are
//                                   taken.
//                                 </li>
//                                 <li>Resolve conflicts.</li>
//                                 <li>
//                                   Ensure all evaluations are accounted for and
//                                   submitted to HR.
//                                 </li>
//                               </ul>
//                               <h3 className="font-semibold mt-4">
//                                 HR Team Responsibilities:
//                               </h3>
//                               <ul className="list-disc ml-6">
//                                 <li>
//                                   Ensure completeness and accuracy of
//                                   evaluations, resolve issues, and place
//                                   completed forms in employee records.
//                                 </li>
//                               </ul>
//                               <p style={{ textAlign: "justify" }}>
//                                 Employee Performance Issues:
//                               </p>

//                               <ul
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   Every employee is expected to perform
//                                   efficiently and effectively in terms of
//                                   Quality, Quantity and Delivery.
//                                 </li>

//                                 <li>
//                                   Every employee will be evaluated continuously
//                                   on periodic bases.
//                                 </li>

//                                 <li>
//                                   For each performance case, the respective
//                                   managers will share the periodic email to the
//                                   employees regarding his performance and
//                                   expectations.
//                                 </li>

//                                 <li>
//                                   Employee should respond to the manager within
//                                   48 hours, otherwise the manager will reroute
//                                   all the concerns to HR department for further
//                                   steps.
//                                 </li>
//                                 <li>
//                                   The HR team will analyse the scenario and take
//                                   necessary actions on the particular cases.
//                                   Sometimes it will lose the position of
//                                   employee or claim for liquidate expenditure.
//                                   Until further resolution all further
//                                   proceedings will be kept on hold from
//                                   department end.
//                                 </li>
//                                 <p>
//                                   <span style={{ marginleft: "-2%" }}>7 </span>
//                                   <b>Performance Appraisal:</b> It is a periodic
//                                   and systematic process. Where the job
//                                   performance of an employee is documented and
//                                   evaluated on the basis of his/ her Quality,
//                                   Quantity and efficiency of work.
//                                 </p>

//                                 <ul
//                                   style={{
//                                     marginRight: "5%",
//                                     textAlign: "justify",
//                                   }}
//                                 >
//                                   <li>
//                                     All our appraisal cycles are evaluated on
//                                     Pro-rate basis. So based on leaves it will
//                                     carry forward and rounded-off to nearest
//                                     slabs.
//                                   </li>

//                                   <li>
//                                     For example, If Employee date of joining is
//                                     August 10th, but due to his family function
//                                     / illness he/ she took more than 15 days/ 1
//                                     month of leave and then his/ her appraisal
//                                     may move forward and heading to next slab
//                                     i.e. October. (Ref: Below Table)
//                                   </li>
//                                 </ul>
//                               </ul>
//                             </div>
//                           )}

//                           {currentPage === 11 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <table
//                                 style={{
//                                   width: "100%",
//                                   textAlign: "center",
//                                 }}
//                               >
//                                 <tr>
//                                   <th>Dates</th>
//                                   <th>Appraisal Month effective from</th>
//                                 </tr>
//                                 <tr>
//                                   <td>April 1st – May 15th</td>
//                                   <td>April 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>May 16th - June 30th</td>
//                                   <td>July 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>July 1st - Aug 15th</td>
//                                   <td>July 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>Aug 16th - Sept 30th</td>
//                                   <td>October 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>Oct 1st - Nov 15th</td>
//                                   <td>October 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>Nov 16th - Dec 31st</td>
//                                   <td>January 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>Jan 1st - Feb 15th</td>
//                                   <td>January 1st</td>
//                                 </tr>

//                                 <tr>
//                                   <td>Feb 16th - March 31s</td>
//                                   <td>April 1st</td>
//                                 </tr>
//                               </table>
//                               <br></br>

//                               <ul
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   Employee will fall nearest slabs as per their
//                                   attendance (Pro-rate basis), based on last
//                                   Appraisal date and Date of payroll (fall ahead
//                                   or behind) w.r.to the mentioned slabs. For any
//                                   clarification contact HR.
//                                 </li>
//                               </ul>
//                               <p>
//                                 <span style={{ marginLeft: "-2%" }}>8. </span>
//                                 <b>Roles and Responsibilities:</b> The Roles and
//                                 Responsibilities of the employee will. Be
//                                 specified by the immediate superior of the
//                                 employee at the time of Joining. Apart from the
//                                 Roles mentioned initially, the Company may
//                                 assign new Roles and Responsibilities to the
//                                 employee as and when required.
//                               </p>

//                               <p>
//                                 <span style={{ marginLeft: "-2%" }}>9. </span>
//                                 <b>Promotions:</b> Based on your Performance
//                                 Appraisals, accordingly you might be promoted to
//                                 a senior position as decided by the organization
//                                 designation levels.
//                               </p>

//                               <p>
//                                 <span style={{ marginLeft: "-2%" }}>10. </span>
//                                 <b>Transfers:</b> You are also liable to be
//                                 transferred to any of the new Offices that the
//                               </p>

//                               <ul
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   Company might open/ deploy or you may at times
//                                   need to work on some of the Company
//                                   assignments in domestic/ International.
//                                   Transfers may involve a promotion,
//                                   reassignment, demotion or lateral move.
//                                 </li>
//                                 <li>
//                                   All transfers will be considered as branch
//                                   transfers and respective policies will takes
//                                   place based on the region/ country.
//                                 </li>
//                               </ul>

//                               <p>
//                                 <span style={{ marginLeft: "-2%" }}>11. </span>
//                                 <b>Skip Level Meeting:</b> Skip level meeting
//                                 provides a platform for employees to communicate
//                                 freely and openly by encouraging bottom up
//                                 communication. It also provides an opportunity
//                                 to the manager’s manager to meet and know the
//                                 team members better and establish “We Care”
//                                 approach.
//                               </p>

//                               <p style={{ textAlign: "justify" }}>Procedure:</p>

//                               <ul
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   Skip Level Manager will be two levels above in
//                                   the hierarchy of the employees participating
//                                   in the Skip Level Meeting.
//                                 </li>
//                                 <li>
//                                   A group of employees (8-12 nos.) of the same
//                                   department may be invited to meet the Skip
//                                   level Manager half-yearly, or it can be
//                                   one-on-one, which is sometimes more effective.
//                                 </li>
//                                 <li>
//                                   The meeting is carried out without the
//                                   presence of the employee’s immediate reporting
//                                   manager.
//                                 </li>
//                                 <li>
//                                   Skip level Manager provides an opportunity for
//                                   the employees to suggest improvements in the
//                                   work place, Business performance and also seek
//                                   clarity on existing/ new systems/ policy.
//                                 </li>
//                                 <li>
//                                   Skip Level Manager takes direct responsibility
//                                   to resolve the queries/ clarifications raised
//                                   during the meeting within two weeks.
//                                 </li>
//                                 <li>
//                                   Some of the Do’s and Don’ts to be followed by
//                                   the employees and Skip Level Managers but not
//                                   limited to the following are:
//                                 </li>
//                               </ul>
//                             </div>
//                           )}
//                           {currentPage === 12 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />

//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "20px",
//                                 }}
//                               >
//                                 COMPENSATION
//                               </h1>

//                               <ol
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   <b> Pay:</b> Your Pay will be according to the
//                                   Pay structure specified in your Appointment
//                                   Letter. You will be paid a Net Salary after
//                                   making the necessary deductions. The Company
//                                   is required by law to deduct the following
//                                   from your pay:
//                                 </li>

//                                 <ul
//                                   style={{
//                                     marginRight: "5%",
//                                     textAlign: "justify",
//                                   }}
//                                 >
//                                   <li>Income Tax at the prevailing rate.</li>

//                                   <li>Professional Tax.</li>

//                                   <li>Provident Fund.</li>

//                                   <li>Gratuity.</li>

//                                   <li>Health Insurance.</li>

//                                   <li>
//                                     Absences from work, which is not covered by
//                                     authorized leave credits
//                                   </li>
//                                 </ul>
//                                 <br></br>
//                                 <li>
//                                   <b>Pay Periods:</b> Your Payday will be on the
//                                   7th day of each month. If this day falls on a
//                                   Saturday, Sunday or a holiday, payday will be
//                                   on the succeeding business day.
//                                 </li>
//                                 <br></br>
//                                 <li>
//                                   <b>Pay Mode:</b> Your Pay Mode will be direct
//                                   deposit to your Salary Account with ICICI
//                                   Bank. You will receive a Salary Slip
//                                   indicating the net amount deposited into your
//                                   account after any additions, subtractions, and
//                                   deductions in your salary.
//                                 </li>
//                                 <br></br>
//                                 <li>
//                                   <b> Domestic Travel:</b> This policy is
//                                   applicable to all employees who travels for
//                                   business purpose on the regular for the
//                                   company. He/ she must apply for the trip up to
//                                   prior 15 days. If Business travel period
//                                   exceeding 8 days, prior permission needs to be
//                                   taken from the HOD, who will, in consultation
//                                   with the HR Department, determine the rules to
//                                   be made applicable.
//                                 </li>
//                               </ol>
//                               <h1
//                                 style={{
//                                   textAlign: "center",
//                                   fontWeight: "bold",
//                                   fontSize: "18px",
//                                 }}
//                               >
//                                 ATTENDANCE AND LEAVES
//                               </h1>
//                               <ol
//                                 style={{
//                                   marginRight: "5%",
//                                   textAlign: "justify",
//                                 }}
//                               >
//                                 <li>
//                                   <b>Attendance:</b> The Company has installed a
//                                   Proximity Card Reader at the entrance of the
//                                   Office, and you are provided with an Identity
//                                   cum Proximity card, which you need to swipe/
//                                   scan in the machine to get your attendance
//                                   recorded. You need to strictly maintain the
//                                   Work schedule assigned to you. The company
//                                   providing web clock-in and clock-out based on
//                                   geographic IP. Every employee strictly clocks
//                                   in and clock out based on their working times
//                                   without any hesitation whether they are in
//                                   Envision group office or its client location.
//                                 </li>
//                                 <li>
//                                   <b>Timings:</b> All offices are running with 3
//                                   shifts i.e. General, 1 and 2.
//                                 </li>

//                                 <ul
//                                   style={{
//                                     marginRight: "5%",
//                                     textAlign: "justify",
//                                   }}
//                                 >
//                                   <li>
//                                     The general office timings are from 9:00
//                                     A.M. in the Morning to 6:30 P.M in the
//                                     Evening, with a one-hour break for Lunch
//                                     from 1:00 P.M to 1:45 P.M (Technical), 1:30
//                                     P.M to 2:15 P.M (OD).
//                                   </li>
//                                   <li>
//                                     The reporting time to the Office (9 A.M)
//                                     will have a grace period of 10 Minutes.
//                                   </li>
//                                   <li>
//                                     Employees reporting to the Office after the
//                                     reporting time will have to undergo Loss of
//                                     Pay for that day, with an exception of two
//                                     such late comings in months.
//                                   </li>
//                                 </ul>
//                               </ol>
//                             </div>
//                           )}
//                           {currentPage === 13 && (
//                             <div className="page page_3" id="top">
//                               <img
//                                 src={envisionLogo1}
//                                 alt="Envision"
//                                 style={{
//                                   width: "120px",
//                                   height: "120px",
//                                   marginLeft: "590px",
//                                   marginTop: "-18%",
//                                 }}
//                               />
//                               <li>
//                                 The above-mentioned rules is exceptional when
//                                 employee have evidence like, Employee has
//                                 notified his Superior in advance of the Late
//                                 Coming for that day in written format.
//                               </li>

//                               <li>
//                                 <b>Holidays:</b> The Company has decided to set
//                                 of days as Holidays. A detailed circular will be
//                                 sent during first week of the year on Festival
//                                 and National Holidays. Refer: Holiday calendar
//                                 or contact HR.
//                               </li>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           alignItems: "center",
//                           marginTop: "20px",
//                           marginBottom: "50px",
//                         }}
//                       >
//                         {/* Previous Button */}
//                         <button
//                           onClick={() => {
//                             handlePrev();
//                             setTimeout(() => {
//                               document.getElementById("top")?.scrollIntoView({
//                                 behavior: "smooth",
//                                 block: "start",
//                               });
//                             }, 100);
//                           }}
//                           disabled={startPage === 1}
//                           style={{
//                             padding: "10px 15px",
//                             margin: "5px",
//                             cursor: startPage === 1 ? "not-allowed" : "pointer",
//                             backgroundColor:
//                               startPage === 1 ? "#ddd" : "#007bff",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "5px",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           Prev
//                         </button>

//                         {/* Page Numbers (Only 3 Visible at a Time) */}
//                         {[...Array(pageLimit)].map((_, index) => {
//                           const pageNumber = startPage + index;
//                           if (pageNumber > totalPages) return null;

//                           return (
//                             <button
//                               key={pageNumber}
//                               onClick={() => {
//                                 setCurrentPage(pageNumber);
//                                 setTimeout(() => {
//                                   document
//                                     .getElementById("top")
//                                     ?.scrollIntoView({
//                                       behavior: "smooth",
//                                       block: "start",
//                                     });
//                                 }, 100);
//                               }}
//                               style={{
//                                 padding: "10px 15px",
//                                 margin: "5px",
//                                 cursor: "pointer",
//                                 backgroundColor:
//                                   pageNumber === currentPage
//                                     ? "#007bff"
//                                     : "#f0f0f0",
//                                 color:
//                                   pageNumber === currentPage
//                                     ? "white"
//                                     : "black",
//                                 border: "none",
//                                 borderRadius: "5px",
//                                 fontWeight: "bold",
//                               }}
//                             >
//                               {pageNumber}
//                             </button>
//                           );
//                         })}

//                         {/* Next Button */}
//                         <button
//                           onClick={() => {
//                             handleNext();
//                             setTimeout(() => {
//                               document.getElementById("top")?.scrollIntoView({
//                                 behavior: "smooth",
//                                 block: "start",
//                               });
//                             }, 100);
//                           }}
//                           disabled={startPage + pageLimit > totalPages}
//                           style={{
//                             padding: "10px 15px",
//                             margin: "5px",
//                             cursor:
//                               startPage + pageLimit > totalPages
//                                 ? "not-allowed"
//                                 : "pointer",
//                             backgroundColor:
//                               startPage + pageLimit > totalPages
//                                 ? "#ddd"
//                                 : "#007bff",
//                             color: "white",
//                             border: "none",
//                             borderRadius: "5px",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           Next
//                         </button>
//                       </div>
//                     </Box>
//                   </DialogContent>
//                 </Dialog>
//               </CardContent>
              
//             </Box>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Summery;




import React, { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import { RemoveRedEye } from "@mui/icons-material";
import { Visibility, Edit, Delete } from "@mui/icons-material";
import { Close } from "@mui/icons-material";
 import layoutImage from "../../../assets/images/girl.webp";
import {
  Box,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Tooltip,
  Dialog,
  DialogActions,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TablePagination,
  DialogContent,
  DialogTitle,
  Modal,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import logo2 from "../../../assets/images/Picture2.png";
import envisionLogo1 from "../../../assets/images/Picture2.png";

import { ExpandMore } from "@mui/icons-material";

const Summery = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  const [showForm, setShowForm] = useState(false);
  const handleAccordionChange = (panel) => {
    setExpandedPanel(expandedPanel === panel ? null : panel);
  };



  const openPersonalView = () => {};
const editPersonal = () => {};

const openFamilyView = () => {};
const editFamily = () => {};

const openEducationView = () => {};
const editEducation = () => {};

const openWorkView = () => {};
const editWorkExperience = () => {};

const openAgreeView = () => {};
const editWorkAgreement = () => {};

const openHandBookView = () => {};
const editHandbook = () => {};



const handleChangeC = () => {};
const selectFileSign2 = () => {};
const closeImage = () => {};
  const handleViewClick = (index) => {
    if (index === 0) {
      setOpenS(true);
    } else if (index === 1) {
      setOpenF(true);
    } else if (index === 2) {
      setOpenE(true);
    } else if (index === 3) {
      setOpenW(true);
    } else if (index === 4) {
      setOpenA(true);
    }
  };
  
  const [selectedSection, setSelectedSection] = useState("PERSONAL");
  const handleEditClick = (index) => {
    if (index === 0) {
      setSelectedSection("PERSONAL");
    } else if (index === 1) {
      setSelectedSection("FAMILY");
    } else if (index === 2) {
      setSelectedSection("EDUCATION");
    } else if (index === 3) {
      setSelectedSection("WORK EXPERIENCE");
    } else if (index === 4) {
      setSelectedSection("AGREEMENT");
    }
  };
  
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const pageLimit = 3;
  const pageLimit1 = 2;
  const totalPages = 23;
  const totalPages1 = 2;
  
  const agreementdata = [
    {
      unit: "10th",
      monthName: "March",
      date: "Twenty Five",
      employeeName: "John Doe",
      employeeFathersName: "Richard Doe",
      age: 30,
      presentAddress: "123, ABC Street, Hyderabad",
      permanentAddress: "456, XYZ Road, Bangalore",
      serviceCommitment: 2,
      custodyOf: "ID Proofs and Bank Cheque",
      serviceBreakAmount: 50000,
      agreementDate: "08/02/2025",
    },
  ];
  
  const [currentPage1, setCurrentPage1] = useState(1);
  const [openA, setOpenA] = useState(false);
  const [openW, setOpenW] = useState(false);
  const [openE, setOpenE] = useState(false);
  const [addresses, setAddresses] = useState([{}]);
  const [openf, setOpenF] = useState(false);



  const [expandedPanel, setExpandedPanel] = useState(null);

  
  const S = [
    {
      id: 1,
      title: "Personal Detials",
      image: "images/iStock.jpg",
      details: "personal",
    },
    { id: 2, title: "Address Detials", image: "pop.png", details: "family" },
    { id: 3, title: "KYC Detials", image: "da.png", details: "education" },
    { id: 4, title: "Bank Detials", image: "pop.png", details: "work" },
    { id: 5, title: "Social Profile", image: "da.png", details: "address" },
  ];
  const cellStyle = {
  borderRight: "1px solid black",
  py: { xs: 0.5, sm: 0.8 },
  px: { xs: 0.8, sm: 1.2 },
  lineHeight: "1.3",
  textAlign: "center",
  fontSize: { xs: "12px", sm: "14px" },
};

  const [opens, setOpenS] = useState(false);
  const data = [
    {
      id: 1,
      description: "Personal",
      status: "Pending",
      viewHandler: () => openPersonalView(1),
      editHandler: () => editPersonal(),
    },
    {
      id: 2,
      description: "Family",
      status: "Pending",
      viewHandler: () => openFamilyView(2),
      editHandler: () => editFamily(),
    },
    {
      id: 3,
      description: "Education",
      status: "Pending",
      viewHandler: () => openEducationView(3),
      editHandler: () => editEducation(),
    },
    {
      id: 4,
      description: "Work Experience",
      status: "Pending",
      viewHandler: () => openWorkView(4),
      editHandler: () => editWorkExperience(),
    },
    {
      id: 5,
      description: "Agreement",
      status: "Pending",
      viewHandler: () => openAgreeView(5),
      editHandler: () => editWorkAgreement(),
    },
  ];

  // Pagination handlers
  const handlePrev = () => {
    if (startPage > 1) {
      setStartPage(startPage - pageLimit);
      setCurrentPage(startPage - pageLimit);
    }
  };

  const handleNext = () => {
    if (startPage + pageLimit <= totalPages) {
      setStartPage(startPage + pageLimit);
      setCurrentPage(startPage + pageLimit);
    }
  };

  const handlePrev1 = () => {
    if (startPage > 1) {
      setStartPage(startPage - pageLimit1);
      setCurrentPage1(startPage - pageLimit1);
    }
  };

  const handleNext1 = () => {
    if (startPage + pageLimit1 <= totalPages1) {
      setStartPage(startPage + pageLimit1);
      setCurrentPage1(startPage + pageLimit1);
    }
  };

  // Responsive table styling
  const getTableStyles = () => {
    if (isMobile) {
      return {
        minWidth: "600px",
        fontSize: "12px",
        '& .MuiTableCell-root': {
          padding: '4px 6px',
          fontSize: '12px',
        }
      };
    } else if (isTablet) {
      return {
        minWidth: "800px",
        fontSize: "13px",
      };
    }
    return {
      minWidth: "1000px",
    };
  };

  const getDialogStyles = () => {
    if (isMobile) {
      return {
        margin: "20px 10px",
        width: "95%",
        maxWidth: "95%",
        height: "80vh",
        marginLeft: "auto",
        marginRight: "auto",
      };
    } else if (isTablet) {
      return {
        margin: "40px 5%",
        width: "90%",
        maxWidth: "90%",
        height: "80vh",
        marginLeft: "auto",
        marginRight: "auto",
      };
    }
    return {
      marginTop: "60px",
      marginLeft: "15%",
      marginRight: "160px",
      height: "80vh",
      borderRadius: "40px",
    };
  };

  const getPersonalDialogStyles = () => {
    if (isMobile) {
      return {
        margin: "20px 5px",
        width: "95%",
        maxWidth: "95%",
        height: "85vh",
        marginLeft: "auto",
        marginRight: "auto",
      };
    }
    return {
      marginTop: "60px",
      marginLeft: "15%",
      marginRight: "160px",
      height: "80vh",
      borderRadius: "40px",
    };
  };

  return (
    <div>
       
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Box
            sx={{
              marginTop: 0, // ✅ removed
              padding: { xs: "0.5rem", sm: "1rem" },
              maxHeight: { xs: "400px", sm: "500px" },
              overflowX: "auto",
              overflowY: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <CardContent sx={{ padding: { xs: 1, sm: 2 } }}>
              <TableContainer
                sx={{
                  marginTop: 0,     // ✅ removed
                  marginBottom: 0,  // ✅ removed
                  overflowX: "auto",
                }}
              >
                <Table sx={getTableStyles()}>
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "#D6E0F5",
                        height: { xs: "35px", sm: "40px" },
                      }}
                    >
                      {["S.No", "Description", "Status", "Action", "Remarks"].map(
                        (head, i) => (
                          <TableCell
                            key={i}
                            sx={{
                              borderRight:
                                head !== "Remarks" ? "1px solid black" : "none",
                              py: { xs: 0.5, sm: 0.8 },
                              px: { xs: 0.8, sm: 1.2 },
                              lineHeight: "1.3",
                              textAlign: "center",
                              fontSize: { xs: "12px", sm: "14px" },
                              whiteSpace: "nowrap",
                            }}
                          >
                            {head}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{ height: { xs: "35px", sm: "40px" } }}
                      >
                        <TableCell sx={cellStyle}>
                          {row.id}
                        </TableCell>

                        <TableCell sx={cellStyle}>
                          {row.description}
                        </TableCell>

                        <TableCell sx={cellStyle}>
                          {row.status}
                        </TableCell>

                        <TableCell sx={cellStyle}>
                          <Tooltip title="View">
                            <IconButton
                              onClick={() => handleViewClick(index)}
                              color="primary"
                              size={isMobile ? "small" : "medium"}
                              sx={{ padding: { xs: "4px", sm: "8px" } }}
                            >
                              <RemoveRedEye
                                fontSize={isMobile ? "small" : "medium"}
                              />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Edit">
                            <IconButton
                              onClick={() => handleEditClick(index)}
                              color="secondary"
                              size={isMobile ? "small" : "medium"}
                              sx={{ padding: { xs: "4px", sm: "8px" } }}
                            >
                              <Edit
                                fontSize={isMobile ? "small" : "medium"}
                              />
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          sx={{
                            py: { xs: 0.5, sm: 0.8 },
                            px: { xs: 0.8, sm: 1.2 },
                            lineHeight: "1.3",
                            textAlign: "center",
                            fontSize: { xs: "12px", sm: "14px" },
                          }}
                        >
                          Nothing
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

                {/* Personal Info Dialog */}
                <Dialog
                  style={getPersonalDialogStyles()}
                  open={opens}
                  onClose={() => setOpenS(false)}
                  maxWidth="md"
                  fullWidth
                  fullScreen={isMobile}
                >
                  <DialogTitle sx={{ fontSize: { xs: '18px', sm: '20px' }, padding: { xs: '12px', sm: '16px' } }}>
                    Personal Info
                    <IconButton
                      onClick={() => setOpenS(false)}
                      sx={{ position: "absolute", right: 8, top: 8 }}
                      size={isMobile ? "small" : "medium"}
                    >
                      <Close color="error" fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ padding: { xs: 1, sm: 2 } }}>
                    {S.map((item, index) => (
                      <Accordion
                        key={item.id}
                        expanded={expandedPanel === index}
                        onChange={() => handleAccordionChange(index)}
                        sx={{ marginBottom: 1 }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          sx={{ backgroundColor: "#D6E0F5", minHeight: '48px' }}
                        >
                          <Typography sx={{ fontSize: { xs: '14px', sm: '16px' } }}>{item.title}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: { xs: 1, sm: 2 } }}>
                          {expandedPanel === index ? (
                            index === 0 ? (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginBottom: "15px",
                                  }}
                                >
                                  <img
                                    src={logo2}
                                    alt="Profile"
                                    style={{
                                      width: isMobile ? 80 : 100,
                                      height: isMobile ? 80 : 100,
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    gap: isMobile ? "10px" : "20px",
                                  }}
                                >
                                  {/* Left Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>First Name</strong>
                                      <br />
                                      Anirudh
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Gender</strong>
                                      <br />
                                      Male
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Mother's Name</strong>
                                      <br />
                                      Srilatha
                                    </p>
                                  </div>

                                  {/* Middle Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Middle Name</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Blood Group</strong>
                                      <br />
                                      A+
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Personal Mail Id</strong>
                                      <br />
                                      anirudhmarripally912@gmail.com
                                    </p>
                                  </div>

                                  {/* Right Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Last Name</strong>
                                      <br />
                                      Marripally
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Marital Status</strong>
                                      <br />
                                      Single
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Phone Number</strong>
                                      <br />
                                      7569532673
                                    </p>
                                  </div>

                                  {/* Extra Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Date Of Birth</strong>
                                      <br />
                                      11-03-1994
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Father's Name</strong>
                                      <br />
                                      Satyanarayana Charyulu
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Alternative Phone Number</strong>
                                      <br />
                                    </p>
                                  </div>
                                </div>
                              </>
                            ) : index === 1 ? (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    gap: isMobile ? "10px" : "20px",
                                  }}
                                >
                                  {/* Left Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Country</strong>
                                      <br />
                                      India
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>State</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>City</strong>
                                      <br />
                                      Jane
                                    </p>
                                  </div>

                                  {/* Middle Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>House No</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Area</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Landmark</strong>
                                      <br />
                                    </p>
                                  </div>

                                  {/* Right Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Pincode</strong>
                                      <br />
                                      Doe
                                    </p>
                                  </div>
                                </div>
                              </>
                            ) : index === 2 ? (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    gap: isMobile ? "10px" : "20px",
                                  }}
                                >
                                  {/* Left Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Aadhar Number</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Pancard Number</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Driving License</strong>
                                      <br />
                                    </p>
                                  </div>

                                  {/* Middle Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Aadhar FrontPage</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Pancard Frontpage</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Driving License FrontPage</strong>
                                      <br />
                                    </p>
                                  </div>

                                  {/* Right Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Aadhar BackPage</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Pancard Backpage</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Driving License Backpage</strong>
                                      <br />
                                    </p>
                                  </div>
                                </div>
                              </>
                            ) : index === 4 ? (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    gap: isMobile ? "10px" : "20px",
                                  }}
                                >
                                  {/* Left Column */}
                                  <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>LinkdIn</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>FaceBook</strong>
                                      <br />
                                    </p>
                                    <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                      <strong>Instagram</strong>
                                      <br />
                                    </p>
                                  </div>
                                </div>
                              </>
                            ) : index === 3 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "space-between",
                                  gap: isMobile ? "10px" : "20px",
                                }}
                              >
                                {/* Left Column */}
                                <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>Bank Holder Name</strong>
                                    <br />
                                  </p>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>Bank Name</strong>
                                    <br />
                                  </p>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>Account Number</strong>
                                    <br />
                                  </p>
                                </div>

                                {/* Middle Column */}
                                <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>IFSC Code</strong>
                                    <br />
                                  </p>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>Branch Name</strong>
                                    <br />
                                  </p>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>Branch City</strong>
                                    <br />
                                  </p>
                                </div>

                                {/* Right Column */}
                                <div style={{ flex: isMobile ? "1 1 100%" : "1" }}>
                                  <p style={{ marginBottom: isMobile ? "8px" : "12px" }}>
                                    <strong>Bank Passbook/Cheque</strong>
                                    <br />
                                  </p>
                                </div>
                              </div>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <img
                                  src={item.image}
                                  alt={item.title}
                                  style={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            )
                          ) : null}
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </DialogContent>
                </Dialog>

                {/* Family Info Dialog */}
                <Dialog
                  style={getDialogStyles()}
                  open={openf}
                  onClose={() => setOpenF(false)}
                  maxWidth="md"
                  fullWidth
                  fullScreen={isMobile}
                >
                  <DialogTitle sx={{ fontSize: { xs: '18px', sm: '20px' }, padding: { xs: '12px', sm: '16px' } }}>
                    Family Info
                    <IconButton
                      onClick={() => setOpenF(false)}
                      sx={{ position: "absolute", right: 8, top: 8 }}
                      size={isMobile ? "small" : "medium"}
                    >
                      <Close color="error" fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ padding: { xs: 1, sm: 2 } }}>
                    <TableContainer
                      component={Paper}
                      sx={{ 
                        border: "1px solid #ccc",
                        overflowX: "auto",
                      }}
                    >
                      <Table sx={{ minWidth: isMobile ? "600px" : "auto" }}>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
                            {[
                              "S.NO",
                              "Name",
                              "Relationship",
                              "Age",
                              "Date Of Birth",
                              "Phone Number",
                              "Pin Code",
                              "Address",
                            ].map((header) => (
                              <TableCell
                                key={header}
                                align="center"
                                sx={{
                                  fontWeight: "bold",
                                  border: "1px solid #ccc",
                                  lineHeight: "1",
                                  fontSize: { xs: "11px", sm: "14px" },
                                  padding: { xs: "4px", sm: "8px" },
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {header}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {addresses.map((_, index) => (
                            <TableRow key={index} sx={{ height: "30px" }}>
                              {[...Array(8)].map((_, i) => (
                                <TableCell
                                  key={i}
                                  align="center"
                                  sx={{
                                    border: "1px solid #ccc",
                                    padding: { xs: "2px", sm: "4px" },
                                    lineHeight: "1",
                                    fontSize: { xs: "11px", sm: "14px" },
                                  }}
                                >
                                  {/* Empty cells */}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </DialogContent>
                </Dialog>

                {/* Education Info Dialog */}
                <Dialog
                  style={getDialogStyles()}
                  open={openE}
                  onClose={() => setOpenE(false)}
                  maxWidth="md"
                  fullWidth
                  fullScreen={isMobile}
                >
                  <DialogTitle sx={{ fontSize: { xs: '18px', sm: '20px' }, padding: { xs: '12px', sm: '16px' } }}>
                    Education Info
                    <IconButton
                      onClick={() => setOpenE(false)}
                      sx={{ position: "absolute", right: 8, top: 8 }}
                      size={isMobile ? "small" : "medium"}
                    >
                      <Close color="error" fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ padding: { xs: 1, sm: 2 } }}>
                    <TableContainer
                      component={Paper}
                      sx={{ 
                        border: "1px solid #ccc",
                        overflowX: "auto",
                      }}
                    >
                      <Table sx={{ minWidth: isMobile ? "600px" : "auto" }}>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
                            {[
                              "S.NO",
                              "Qualification",
                              "Course Type",
                              "Stream",
                              "Start Date",
                              "End Date",
                              "College/University",
                            ].map((header) => (
                              <TableCell
                                key={header}
                                align="center"
                                sx={{
                                  fontWeight: "bold",
                                  border: "1px solid #ccc",
                                  lineHeight: "1",
                                  fontSize: { xs: "11px", sm: "14px" },
                                  padding: { xs: "4px", sm: "8px" },
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {header}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {addresses.map((_, index) => (
                            <TableRow key={index} sx={{ height: "30px" }}>
                              {[...Array(7)].map((_, i) => (
                                <TableCell
                                  key={i}
                                  align="center"
                                  sx={{
                                    border: "1px solid #ccc",
                                    padding: { xs: "2px", sm: "4px" },
                                    lineHeight: "1",
                                    fontSize: { xs: "11px", sm: "14px" },
                                  }}
                                >
                                  {/* Empty cells */}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </DialogContent>
                </Dialog>

                {/* Work Info Dialog */}
                <Dialog
                  style={getDialogStyles()}
                  open={openW}
                  onClose={() => setOpenW(false)}
                  maxWidth="md"
                  fullWidth
                  fullScreen={isMobile}
                >
                  <DialogTitle sx={{ fontSize: { xs: '18px', sm: '20px' }, padding: { xs: '12px', sm: '16px' } }}>
                    Work Info
                    <IconButton
                      onClick={() => setOpenW(false)}
                      sx={{ position: "absolute", right: 8, top: 8 }}
                      size={isMobile ? "small" : "medium"}
                    >
                      <Close color="error" fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ padding: { xs: 1, sm: 2 } }}>
                    <TableContainer
                      component={Paper}
                      sx={{ 
                        border: "1px solid #ccc",
                        overflowX: "auto",
                      }}
                    >
                      <Table sx={{ minWidth: isMobile ? "600px" : "auto" }}>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: "#D6E0F5" }}>
                            {[
                              "S.NO",
                              "Company Name",
                              "Previous Designation",
                              "Tenure(To)",
                              "Tenure(From)",
                              "Last CTC",
                              "College/University",
                            ].map((header) => (
                              <TableCell
                                key={header}
                                align="center"
                                sx={{
                                  fontWeight: "bold",
                                  border: "1px solid #ccc",
                                  lineHeight: "1",
                                  fontSize: { xs: "11px", sm: "14px" },
                                  padding: { xs: "4px", sm: "8px" },
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {header}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {addresses.map((_, index) => (
                            <TableRow key={index} sx={{ height: "30px" }}>
                              {[...Array(6)].map((_, i) => (
                                <TableCell
                                  key={i}
                                  align="center"
                                  sx={{
                                    border: "1px solid #ccc",
                                    padding: { xs: "2px", sm: "4px" },
                                    lineHeight: "1",
                                    fontSize: { xs: "11px", sm: "14px" },
                                  }}
                                >
                                  {/* Empty cells */}
                                </TableCell>
                              ))}
                              <TableCell
                                align="center"
                                sx={{
                                  border: "1px solid #ccc",
                                  padding: { xs: "2px", sm: "4px" },
                                }}
                              ></TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </DialogContent>
                </Dialog>

                {/* Agreement Info Dialog */}
                <Dialog
                  style={getDialogStyles()}
                  open={openA}
                  onClose={() => setOpenA(false)}
                  maxWidth="md"
                  fullWidth
                  fullScreen={isMobile}
                >
                  <DialogTitle sx={{ fontSize: { xs: '18px', sm: '20px' }, padding: { xs: '12px', sm: '16px' } }}>
                    Agreement Info
                    <IconButton
                      onClick={() => setOpenA(false)}
                      sx={{ position: "absolute", right: 8, top: 8 }}
                      size={isMobile ? "small" : "medium"}
                    >
                      <Close color="error" fontSize={isMobile ? "small" : "medium"} />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent sx={{ padding: { xs: 1, sm: 2 }, overflow: 'auto' }}>
                    <div
                      id="top"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: isMobile ? "auto" : "100vh",
                        padding: isMobile ? "10px" : "0",
                      }}
                    >
                      <div
                        style={{
                          width: isMobile ? "100%" : "210mm",
                          height: isMobile ? "auto" : "297mm",
                          backgroundColor: "white",
                          padding: isMobile ? "5mm" : "10mm",
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                          overflow: "hidden",
                          borderRadius: "5px",
                        }}
                      >
                        {agreementdata.map((data, index) => (
                          <div
                            key={index}
                            style={{
                              letterSpacing: "0.2px",
                              textAlign: "justify",
                              fontSize: isMobile ? "14px" : "16px",
                            }}
                          >
                            {currentPage1 === 1 && (
                              <>
                                <p>
                                  THIS AGREEMENT made at Hyderabad on{" "}
                                  <b>{data.unit}</b> day of{" "}
                                  <b>{data.monthName}</b>, Two thousand and{" "}
                                  <b>{data.date}</b>. BETWEEN
                                  <b> {data.employeeName}</b>, S/o, D/o{" "}
                                  <b>{data.employeeFathersName}</b>, aged{" "}
                                  <b>{data.age}</b> years, residing at{" "}
                                  <b>{data.presentAddress}</b> and having
                                  permanent address at{" "}
                                  <b>{data.permanentAddress}</b>.
                                </p>

                                <p style={{ textAlign: "center" }}>
                                  <b>AND</b>
                                </p>

                                <p>
                                  Envision Integrated Services Private Limited,
                                  a company incorporated under the Companies Act
                                  1956 and having its Corporate Office at #913,
                                  9th Floor, Manjeera Trinity Corporate
                                  Building, E-Seva Lane, KPHB, Hyderabad –
                                  500085, Reg. Office at #8-3-940/5/501,
                                  Tirumala Apartments, Yellareddyguda Cross
                                  Roads, Ameerpet, Hyderabad, Telangana – 500038
                                  (hereinafter referred to as "Employer").
                                </p>

                                <p
                                  style={{
                                    letterSpacing: "0.8px",
                                    fontSize: isMobile ? "16px" : "18px",
                                    fontWeight: "bold",
                                    textDecoration: "underline",
                                  }}
                                >
                                  IT IS NOW HEREBY AGREED AS UNDER:
                                </p>

                                <p>
                                  In consideration of the profession to be
                                  imparted by the Employer, the Employee
                                  undertakes irrevocably to serve the Employer
                                  for a minimum period of{" "}
                                  <b>{data.serviceCommitment}</b> year(s) from
                                  the date of joining.
                                </p>

                                <p>
                                  As a guarantee, the Employee agrees to keep
                                  the following original documents & Bank
                                  Cheques with the custody of the Employer:{" "}
                                  <b>{data.custodyOf}</b>.
                                </p>

                                <p>
                                  If the Employee resigns within the agreed
                                  period, they shall be liable to pay liquidated
                                  damages amounting to Rs{" "}
                                  <b>
                                    {data.serviceBreakAmount
                                      ? data.serviceBreakAmount.toLocaleString(
                                          "en-IN"
                                        )
                                      : ""}
                                  </b>{" "}
                                  /- (Rupees{" "}
                                  <b>
                                    {data.serviceBreakAmount
                                      ? data.serviceBreakAmount.toLocaleString(
                                          "en-IN"
                                        )
                                      : ""}
                                  </b>{" "}
                                  Only).
                                </p>

                                <p>
                                  In case of an unauthorized absence of more
                                  than three consecutive days, the Employer can
                                  claim the employee's cheque no.{" "}
                                  <input
                                    maxLength="6"
                                    type="text"
                                    name="claim"
                                    style={{
                                      width: isMobile ? "60px" : "100px",
                                      border: "0",
                                      outline: "none",
                                      fontSize: isMobile ? "13px" : "15px",
                                      letterSpacing: "2px",
                                      borderBottom: "1px dashed black",
                                    }}
                                  />
                                  ,{" "}
                                  <input
                                    maxLength="6"
                                    type="text"
                                    name="claim1"
                                    style={{
                                      width: isMobile ? "60px" : "100px",
                                      border: "0",
                                      outline: "none",
                                      fontSize: isMobile ? "13px" : "15px",
                                      letterSpacing: "2px",
                                      borderBottom: "1px dashed black",
                                    }}
                                  />{" "}
                                  for liquidated damages/compensation.
                                </p>

                                <p>
                                  Any dispute arising from this agreement shall
                                  be resolved by arbitration in Hyderabad as per
                                  The Arbitration and Conciliation Act, 1996 or
                                  of any modification or re-enactment thereof.
                                  The venue of arbitration shall be Hyderabad.
                                </p>
                                <p>
                                  During the period of{" "}
                                  <span style={{ fontWeight: "bold" }}>2</span>{" "}
                                  year (excluding Leave without pay period
                                  and/or unauthorized absence, if any) from the
                                  date of joining, if Employee
                                  leaves/resigns/abandons the services or
                                  violates the terms of this Agreement, Employee
                                  will have to pay liquidated damages amounting
                                  to Rs{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    2000
                                  </span>{" "}
                                  /- (Rupees{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    Only
                                  </span>
                                  ) and give Three calendar months' written
                                  notice or salary in lieu thereof. Employee
                                  agrees that the said amount of Rs
                                  <span style={{ fontWeight: "bold" }}>
                                    1000
                                  </span>{" "}
                                  /- (Rupees{" "}
                                  <span style={{ fontWeight: "bold" }}>
                                    Only
                                  </span>
                                  ) can be recovered/adjusted by Employer from
                                  the legal dues, if any, payable to him/her. On
                                  being absorbed as an Employee of Employer,
                                  after completion of the said period, Employer
                                  would be entitled to terminate the services of
                                  the Employee with Three Calendar Months'
                                  written notice during the tenure of the
                                  service agreement.
                                </p>
                                <p>
                                  The provisions stated herein for breach by
                                  Employee of the provisions of this agreement
                                  shall be without prejudice to other remedies
                                  available to Employer. In case of any dispute
                                  arising out of the Agreement, it shall be
                                  subject to the jurisdiction of the appropriate
                                  Court of Hyderabad, Telangana, India.
                                </p>
                              </>
                            )}

                            {currentPage1 === 2 && (
                              <>
                                <Typography
                                  sx={{
                                    letterSpacing: "0.5px",
                                    fontSize: isMobile ? "16px" : "20px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  IN WITNESS WHEREOF, THIS AGREEMENT TO BE
                                  EXECUTED AS DATE FIRST MENTIONED ABOVE.
                                </Typography>

                                <Typography
                                  sx={{
                                    letterSpacing: "0.2px",
                                    textAlign: "justify",
                                    mt: 1,
                                  }}
                                >
                                  I solely accept to submit my original
                                  documents & Bank Cheques for the period of my
                                  employment with the company. The company or
                                  any individual has never forced or mandated me
                                  to submit them, but it is limited to security
                                  towards my agreed service tenure with the
                                  company.
                                </Typography>

                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    mt: 0,
                                  }}
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        // checked={checked}
                                        // onChange={handleChangeC}
                                      />
                                    }
                                    label="Terms & Conditions"
                                  />
                                </Box>

                                <h2
                                  style={{ fontSize: isMobile ? "16px" : "18px" }}
                                  className="text-center text-lg font-bold underline mb-1"
                                >
                                  NON-DISCLOSURE AGREEMENT
                                </h2>

                                <p className="text-justify mb-1">
                                  THIS AGREEMENT made at Hyderabad on{" "}
                                  <span className="font-bold">
                                    {data?.unit}
                                  </span>{" "}
                                  day of{" "}
                                  <span className="font-bold">
                                    {data?.monthName}
                                  </span>
                                  , Two thousand and{" "}
                                  <span className="font-bold">
                                    {data?.date}
                                  </span>
                                  .
                                </p>
                                <p className="text-justify mb-1">
                                  This is to certify that I, Mr./Ms{" "}
                                  <span className="font-bold">
                                    {data?.employeeName}
                                  </span>{" "}
                                  have joined ENVISION INTEGRATED SERVICES
                                  PRIVATE LIMITED and executed an agreement on{" "}
                                  <span className="font-bold">
                                    {data?.agreementDate}
                                  </span>
                                  .
                                </p>
                                <h3
                                  style={{ fontSize: isMobile ? "16px" : "18px" }}
                                  className="text-center text-lg font-bold underline mb-1"
                                >
                                  I HEREBY GIVE THE FOLLOWING UNDERTAKING:
                                </h3>
                                <ul className="list-decimal pl-6 text-justify space-y-2">
                                  <li>
                                    I am not involved in any civil/criminal
                                    cases, proceedings, charges, or enquiry
                                    before joining Envision Integrated Services
                                    Pvt. Ltd.
                                  </li>
                                  <li>
                                    I am not involved in any disciplinary
                                    actions or malpractices before joining
                                    Envision Integrated Services Pvt. Ltd.
                                  </li>
                                  <li>
                                    I was not employed gainfully or on an
                                    honorary basis in any organization before
                                    joining Envision Integrated Services Pvt.
                                    Ltd.
                                  </li>
                                  <li>
                                    I will protect confidential information and
                                    will not share it without proper
                                    authorization.
                                  </li>
                                  <li>
                                    Any unintentional breach of this policy will
                                    be investigated and may be punished
                                    appropriately.
                                  </li>
                                  <li>
                                    I will abide by all company policies, rules,
                                    and regulations currently prevailing or
                                    established in the future.
                                  </li>
                                  <li>
                                    I will not approach any of the company's
                                    clients, vendors, or associates for two
                                    years after termination/resignation.
                                  </li>
                                  <li>
                                    The company may terminate this agreement
                                    with one month's notice if I:
                                    <ul className="list-disc pl-6">
                                      <li>
                                        Commit any material or persistent breach
                                        of provisions.
                                      </li>
                                      <li>
                                        Am guilty of any misconduct or neglect
                                        affecting the company's business.
                                      </li>
                                    </ul>
                                  </li>
                                  <li>
                                    I shall keep all proprietary information
                                    confidential in accordance with the NDA.
                                  </li>
                                  <li>
                                    If any statement in this agreement is found
                                    false, the company has the right to
                                    terminate my services and take legal action.
                                  </li>
                                  <li>
                                    I will indemnify and protect the company
                                    from any loss or liability caused by my
                                    actions.
                                  </li>
                                  <li>
                                    I affirm that all the above statements are
                                    true to my knowledge and belief.
                                  </li>
                                </ul>

                                <div className="row" style={{ marginTop: "20px" }}>
                                  <div className="col">
                                    <br />
                                    Name of the Employee:{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {data?.employeeName}
                                    </span>
                                  </div>
                                  <div
                                    className="col"
                                    style={{ marginTop: "17px" }}
                                  >
                                    Date:{" "}
                                    <span style={{ fontWeight: "bold" }}>
                                      {data.agreementDate}
                                    </span>
                                  </div>

                                  <div
                                    style={{ marginTop: "10px" }}
                                    className="row"
                                  >
                                    <div className="col">
                                      <span>Signature: </span>
                                      <br />
                                      <small>JPEG/PNG/JPG</small>
                                      <br />
                                      <small>
                                        (Upload File Size: 1 MB - 2 MB)
                                      </small>
                                    </div>
                                    <div
                                      style={{
                                        marginLeft: isMobile ? "0" : "370px",
                                        marginTop: isMobile ? "10px" : "-85px",
                                      }}
                                      className="col"
                                    >
                                      <span
                                        style={{
                                          display: "inline-block",
                                          minWidth: "auto",
                                          marginRight: "0px",
                                        }}
                                      >
                                        Left Hand Thumb Impression:
                                      </span>
                                      <br />
                                      <small>JPEG/PNG/JPG</small>
                                      <br />
                                      <small>
                                        (Upload File Size: 1 MB - 2 MB)
                                      </small>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "20px",
                        marginBottom: "20px",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Previous Button */}
                      <button
                        onClick={() => {
                          handlePrev1();
                          setTimeout(() => {
                            document.getElementById("top")?.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            });
                          }, 100);
                        }}
                        disabled={startPage === 1}
                        style={{
                          padding: "8px 12px",
                          margin: "3px",
                          cursor: startPage === 1 ? "not-allowed" : "pointer",
                          backgroundColor: startPage === 1 ? "#ddd" : "#007bff",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          fontWeight: "bold",
                          fontSize: isMobile ? "12px" : "14px",
                        }}
                      >
                        Prev
                      </button>

                      {/* Page Numbers */}
                      {[...Array(pageLimit1)].map((_, index) => {
                        const pageNumber = startPage + index;
                        if (pageNumber > totalPages1) return null;

                        return (
                          <button
                            key={pageNumber}
                            onClick={() => {
                              setCurrentPage1(pageNumber);
                              setTimeout(() => {
                                document.getElementById("top")?.scrollIntoView({
                                  behavior: "smooth",
                                  block: "start",
                                });
                              }, 100);
                            }}
                            style={{
                              padding: "8px 12px",
                              margin: "3px",
                              cursor: "pointer",
                              backgroundColor:
                                pageNumber === currentPage1
                                  ? "#007bff"
                                  : "#f0f0f0",
                              color:
                                pageNumber === currentPage1 ? "white" : "black",
                              border: "none",
                              borderRadius: "5px",
                              fontWeight: "bold",
                              fontSize: isMobile ? "12px" : "14px",
                            }}
                          >
                            {pageNumber}
                          </button>
                        );
                      })}

                      {/* Next Button */}
                      <button
                        onClick={() => {
                          handleNext1();
                          setTimeout(() => {
                            document.getElementById("top")?.scrollIntoView({
                              behavior: "smooth",
                              block: "start",
                            });
                          }, 100);
                        }}
                        disabled={startPage + pageLimit1 > totalPages1}
                        style={{
                          padding: "8px 12px",
                          margin: "3px",
                          cursor:
                            startPage + pageLimit1 > totalPages1
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor:
                            startPage + pageLimit1 > totalPages1
                              ? "#ddd"
                              : "#007bff",
                          color: "white",
                          border: "none",
                          borderRadius: "5px",
                          fontWeight: "bold",
                          fontSize: isMobile ? "12px" : "14px",
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </DialogContent>
                </Dialog>
              </CardContent>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Summery;
